<div class="menubar-hoverable header-fixed menubar-pin "
  style="font-family: 'Roboto', sans-serif, Helvetica, Arial, sans-serif;font-size: 13px;line-height: 1.846153846;color: #313534;background-color: #ffffff;">
  <!-- header -->
  <!--  -->
  <!-- BEGIN BASE-->
  <div id="base">
    <!-- BEGIN CONTENT-->
    <div id="content">
      <!-- BEGIN BLANK SECTION -->
      <section>
        <div class="row">
          <div class="col-lg-12">
            <h2 class="text-primary" style="margin-bottom: 5px;"> {{'manageGroups' | translate}}</h2>
          </div>
          <!--end .col -->
          <div class="col-lg-6">
            <article class="margin-bottom-xxl">
              <p class="lead" style="color: #828282;">
                {{ 'createAndManageStaffsStudents' | translate }}
              </p>
            </article>
          </div>
          <!--end .col -->
        </div>
        <div class="section-body">
          <!-- BEGIN LAYOUT LEFT ALIGNED -->
          <div id="clear-selected-students"></div>
          <div class="">
            <div class="card">
              <div class="card-head">
              <ul class="nav nav-tabs" data-toggle="tabs">
                <li [class.active]="activeTab === 'student'"
                  [style.display]="permissions.SCHOOL_STUDENT_MANAGEMENT == 'ENABLED' ? '' : 'none'">
                  <a id="student_tab" style="cursor: pointer" data-target="#first1" data-toggle="tab">
                    <i class="fa fa-users"></i> {{ 'students' | translate }}
                  </a>
                </li>
                <li [class.active]="activeTab === 'staff'"
                  [style.display]="permissions.SCHOOL_STAFFS_MANAGEMENT == 'ENABLED' ? '' : 'none'">
                  <a id="staff_tab" style="cursor: pointer" data-target="#second1" data-toggle="tab">
                    <i class="fa fa-user-plus"></i> {{ 'staffs' | translate }}
                  </a>
                </li>
              </ul>
              </div>
              <!--end .card-head -->
              <div class="card-body tab-content">
                <div class="tab-pane" [class.active]="activeTab === 'student'" id="first1">
                  <h3 style="text-align: center;font-weight: 100;margin: 0;color: #777777;">{{ 'listOfStudentsForTheAcademicYear' | translate }}
                    <span style="color: var(--filter-dropdown-color)">
                      <select [(ngModel)]="academicInfo.current_academic" (change)="academicChanged()"
                        style="border:none">
                        <option *ngFor="let ac of academicInfo.academicList" [ngValue]="ac.pkAcademicId">
                          {{ ac.Year }}{{ac.current ? ('current'|translate):''}}
                        </option>
                      </select>
                    </span>
                    <!-- <div class="btn-group" style="margin-top: -5px;margin-left: 5px;">
                      <span data-toggle="dropdown" style="color:var(--brand-primary-color);border-bottom: 1px solid;cursor: pointer;letter-spacing:1px;">{{schoolAcademicCurrentYear}}</span>
                      <ul class="select-academic dropdown-menu animation-expand" role="menu" style="padding: 0;height: 200px;overflow: auto;">
                        <li *ngFor="let academic of schoolAcademicList" class="" [class.active-academic]="!academic.InActive">
                          <a>{{academic.Year}}
                            <span style="display: none" *ngIf="!academic.InActive" #currentacademic>{{academic.Year}}</span>
                            <p class="p-academic" *ngIf="!academic.InActive">active academic</p>
                            <p class="p-academic" *ngIf="academic.InActive">inactive academic</p>
                          </a>
                        </li>
                        <li class="divider"></li>
                      </ul>
                    </div> -->
                  </h3>
                  <form class="form-inline text-center search-groups" autocomplete="off">
                    <div class="form-group">
                      <h4 style="color: #6b6b6b;font-weight: 300;"> {{ 'filterStudentsBy' | translate }}: </h4>
                    </div>
                    <div class="form-group">
                      <select id="groups-category" name="select13" class="form-control"
                        style="text-transform: uppercase;border-bottom: 1px solid;"
                        (change)="selectcategoryFunction($event.target.value)">

                        <option value="0">{{ 'allCategories' | translate }}</option>
                        <option *ngFor="let category of schoolCategories" value="{{category.categoryId}}">
                          {{category.categoryName}}</option>
                      </select>
                      <div class="form-control-line"></div>
                    </div>
                    <div class="form-group">
                      <select id="select14" name="select13" class="form-control"
                        style="text-transform: uppercase;border-bottom: 1px solid;"
                        [attr.disabled]="selectClassStatus ? true : null"
                        (change)="selectclassFunction($event.target.value)">
                        <option value="0">{{ 'selectClass' | translate }}</option>
                        <option *ngFor="let class of schoolClasses" value="{{class.classid}}">{{class.classname}}
                        </option>
                      </select>
                      <div class="form-control-line"></div>
                    </div>
                    <div class="form-group">
                      <select id="select15" name="select13" class="form-control"
                        style="text-transform: uppercase;border-bottom: 1px solid;"
                        [attr.disabled]="selectClassSectionStatus ? true : null"
                        (change)="selectsectionFunction($event.target.value)">
                        <option value="0">{{ 'selectSection' | translate }}</option>
                        <option *ngFor="let section of schoolClassesSections" value="{{section.claaSectionId}}">
                          {{section.classSection}}</option>
                      </select>
                      <div class="form-control-line"></div>
                    </div>
                    <div *ngIf="permissions.ADD_STUDENT == 'ENABLED' || permissions.IMPORT_STUDENT == 'ENABLED' "
                      class="btn-group">
                      <button type="button" class="btn btn-raised ink-reaction btn-info" data-toggle="dropdown"  *ngIf="academicInfo.current_academic_state === 'RUNNING'"
                        aria-expanded="false">
                        {{ 'addStudent' | translate }} </button>
                      <ul class="dropdown-menu animation-expand" role="menu" style="cursor: pointer">
                        <li><a *ngIf="permissions.ADD_STUDENT == 'ENABLED'" data-toggle="offcanvas"
                            (click)="addNewStudentButton()">{{ 'addNewStudent' | translate }}</a></li>
                        <li><a *ngIf="permissions.IMPORT_STUDENT == 'ENABLED'" class="bulkUploadStudent"
                            data-toggle="modal" data-target="#bulkUploadSTudent" (click)="openStudentImportForm()"
                            disabled>{{ 'importStudents' | translate }}</a></li>
                        <li class="divider"></li>
                        <li><a data-dismiss="modal" aria-hidden="true"><i class="fa fa-fw fa-times text-danger"></i>
                            {{ 'cancel' | translate }}</a></li>
                      </ul>
                    </div>
                  </form>
                  <div *ngIf="selectedSection && academicInfo.current_academic_state === 'RUNNING'"
                    style="text-align: center;color: var(--brand-primary-color);margin-top: 10px;z-index: 20;"><a
                      style="text-decoration: underline;cursor: pointer;" data-toggle="modal"
                      data-target="#update-student-rool-number-confirm" class="table-header-action-item">{{ 'updateStudentRollnumbersToAlphabetOrder' | translate }}</a></div>
                  <div *ngIf="selectedSection && permissions.EDIT_STUDENT == 'ENABLED'"
                    class="update-roll-number-trigger">
                    <button type="button" id="open-update-roll-number-popup" class="update-roll-number-btn"
                      (click)="openUpdateRollNumberPopup()">
                      <i class="pi pi-sort-numeric-up"></i>
                      {{ 'updateRollNumber' | translate }}
                    </button>
                  </div>
                  <div style="margin: 1em 0em;">

                    <!--View student-->
                    <div class="table-responsive">
                      <!--<div style="text-align: center">
                        <button (click)="print_bulk_id_cards()" class="btn btn-raised ink-reaction btn-info" *ngIf="selectedStudentsInTable.length > 0">Print {{selectedStudentsInTable.length}} ID card(s)</button>
                      </div>
                      <br>-->
                     <table id="groups-student-list" class="table table-striped" cellspacing="0" width="100%">
  <thead>
    <tr>
      <th>S.No</th> 
      <th id="rollNoHeader"></th>
      <th id="registrationNoHeader"></th>
      <th id="studentHeader"></th>
      <th id="parentHeader"></th>
      <th id="motherHeader"></th>
      <th id="classHeader"></th>
      <th id="mobileNumberHeader"></th>
      <th id="admissionDateHeader"></th>
      <th id="dateOfBirthHeader"></th>
      <th id="genderHeader"></th>
      <th id="isAppUserHeader"></th>
      <th id="emailIdHeader"></th>
      <th id="surnameHeader"></th>
      <th id="addressHeader"></th>
      <th id="guardianHeader"></th>
      <th id="aadharNoHeader"></th>
      <th id="houseNameHeader"></th>
      <th id="bloodGroupHeader"></th>
      <th id="tcBirthCertificateUploadedHeader"></th>
      <th id="busNameHeader"></th>
      <th id="boardingPointHeader"></th>
      <th id="actionHeader"
        [style.display]="academicInfo.current_academic_state === 'RUNNING' || academicInfo.current_academic_state === 'NOT_STARTED' ? '' : 'none'">
      </th>
      <th id="printIdHeader" style="width: 10% !important;">
        <label *ngIf="true" class='checkbox-inline checkbox-styled checkbox-primary'>
          <input (change)="selectAllStudentsInTable()" id='student-select-check-box-all' type='checkbox'>
          <span class='checkbox-material'><span class='check'></span></span>
        </label>
      </th>
    </tr>
  </thead>
</table>

                    </div>
                  </div>
                  <div class="fixed-action-btn horizontal" style="display:none;bottom: 10em; right: 24px;">
                    <button type="button" class="btn ink-reaction btn-floating-action btn-primary"
                      style="background: #E91E63;border: none;width: 60px;height: 60px;"><i
                        class="fa fa-plus"></i></button>
                    <ul>
                      <li data-toggle="tooltip" data-placement="left" title="" data-original-title="Bulk Upload">
                        <button data-toggle="modal" data-target="#simpleModalupload" type="button"
                          class="upload-bulk btn ink-reaction btn-floating-action btn-primary"><i
                            class="fa fa-upload"></i></button>
                      </li>
                      <li data-toggle="tooltip" data-placement="left" title="" data-original-title="Add Student">
                        <button data-toggle="modal" data-target="#simpleModal" type="button"
                          class="upload-new btn ink-reaction btn-floating-action btn-primary"><i
                            class="fa fa-user-plus"></i></button>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="tab-pane" [class.active]="activeTab === 'staff'" id="second1">
                  <h3 style="text-align: center;font-weight: 100;margin: 0;color: #777777;">{{ 'listOfAllStaffsInTheSchool' | translate }}
                  </h3>
                  <form class="form-inline text-center search-groups" autocomplete="off">
                    <div class="form-group">
                      <h4 style="color: #6b6b6b;font-weight: 300;"> {{ 'filterStaffBy' | translate }}: </h4>
                    </div>
                    <div class="form-group">
                      <select id="staff-category" name="select13" class="form-control"
                        (change)="selectdesignationFunction($event.target.value)">
                        <option value="all">{{ 'allStaffs' | translate }}</option>
                        <option *ngFor="let designation of schoolDesignationList" value="{{designation.designationId}}">
                          {{designation.designation}}</option>
                      </select>
                      <div class="form-control-line"></div>
                    </div>

                    <div class="form-group">

                      <select id="select18" name="select13" class="form-control"
                        (change)="selectstaffStatusFunction($event.target.value)">
                        <option value="all">{{ 'appUserActiveInactive' | translate }}</option>
                        <option value="1">{{ 'appUserActive' | translate }}</option>
                        <option value="0">{{ 'appUserInactive' | translate }}</option>
                      </select>
                      <div class="form-control-line"></div>
                    </div>

                    <div
                      *ngIf="permissions.ADD_STAFF == 'ENABLED' || permissions.ADD_QUALIFICATION == 'ENABLED' || permissions.ADD_DESIGNATION == 'ENABLED'"
                      class="btn-group">
                      <button type="button" class="btn btn-raised ink-reaction btn-info" data-toggle="dropdown"
                        aria-expanded="false">
                        {{ 'addStaff' | translate }}
                      </button>
                      <ul class="dropdown-menu animation-expand" role="menu" style="cursor: pointer">

                        <li *ngIf="permissions.ADD_STAFF == 'ENABLED'"><a (click)="addNewStaffButton()">{{ 'addNewStaff' | translate }}</a></li>
                        <li
                          *ngIf="(permissions.ADD_STAFF == 'ENABLED' && (permissions.ADD_QUALIFICATION == 'ENABLED' || permissions.ADD_DESIGNATION == 'ENABLED'))"
                          class="divider"></li>
                        <li *ngIf="permissions.ADD_DESIGNATION == 'ENABLED'"><a
                            (click)="addDesignation()">{{ 'designation' | translate }}</a></li>
                        <li *ngIf="permissions.ADD_QUALIFICATION == 'ENABLED'"><a
                            (click)="addQualification()">{{ 'qualification' | translate }}</a></li>
                        <li class="divider"></li>
                        <li><a data-dismiss="modal" aria-hidden="true"><i class="fa fa-fw fa-times text-danger"></i>
                           {{ 'cancel' | translate }}</a></li>
                      </ul>
                    </div>
                    <div *ngIf="permissions.SCHOOL_STAFFS_MANAGEMENT == 'ENABLED'" class="btn-group" style="margin-left: 8px;">
                      <button type="button" class="btn btn-raised ink-reaction btn-info" (click)="exportStaffToExcel()"
                        [disabled]="exportingStaff || !staffListHasData">
                        <span *ngIf="!exportingStaff">{{ 'exportStaff' | translate }}</span>
                        <span *ngIf="exportingStaff">{{ 'pleaseWait' | translate }}</span>
                      </button>
                    </div>
                  </form>

                  <div style="margin: 1em 0em;">
                    <div class="table-responsive group-student">
                   
                      <table id="staff-list-table" class="table table-striped " cellspacing="0" width="100%">
                        <thead>
                          <tr>
                            <th>{{ 'staffName' | translate }}</th>
                            <th>{{ 'empid' | translate }}</th>
                            <th>{{ 'designation' | translate }}</th>
                            <th>{{ 'email' | translate }}</th>
                            <th>{{ 'contactNumber' | translate }}</th>
                            <th>{{ 'gender' | translate }}</th>
                            <th>{{ 'bluewingsAppStatus' | translate }}</th>
                            <th id="printIdHeader" style="width: 10% !important; text-align: center;">
                            <div style="display: flex; align-items: center; justify-content: center; gap: 5px;">
                              <span>{{ 'printId' | translate }}</span>
                              <label class="checkbox-inline checkbox-styled checkbox-primary" style="margin: 0;">
                                <input (change)="selectAllStaffsInTable()" id="staff-select-check-box-all" type="checkbox">
                                <span class="checkbox-material"><span class="check"></span></span>
                              </label>
                            </div>
                          </th>
                          </tr>
                        </thead>
                        <tbody>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--end .card-body -->
          </div>
          <!--end .card -->
        </div>
        <!--end .col -->
        <!-- END LAYOUT LEFT ALIGNED -->
        <!--end .section-body -->
      </section>
      <!-- BEGIN BLANK SECTION -->
    </div>
    <!--end #content-->
    <!-- END CONTENT -->

    <!-- Student Update History Modal Popup -->
    <div class="modal fade" id="student-update-history-popup" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog" style="padding: 5em 0 0 0;width: 65vw">
        <div class="modal-content" style="padding: 0 1.5em 1em 1.5em;border: 2px solid;width: 80vw">
          <button style="background-color: var(--brand-primary-color);margin-right: -2em;margin-top: -1.5em;float: right;border: none;"
            type="button" class="btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal"
            aria-hidden="true">&times;</button>
          <h3 style="text-align: center;color: var(--brand-primary-color);">{{ 'updateHistory' | translate }}</h3>
          <h4 style="text-align: center;">
            {{ 'registrationNo' | translate }}: <span id="studentInfoRegistration"></span>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            {{ 'student' | translate }}: <span id="studentInfoName"></span>
          </h4>
          <table id="student-update-history-component-table" class="table table-striped" style="table-layout: fixed;">
            <thead>
              <tr>
                <th>{{ 'fieldName' | translate }}</th>
                <th>{{ 'oldValue' | translate }}</th>
                <th>{{ 'updatedValue' | translate }}</th>
                <th>{{ 'updatedBy' | translate }}</th>
                <th>{{ 'updatedOn' | translate }}</th>
              </tr>
            </thead>
            <tbody>

            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- End of Student Update History Modal  -->



    <!-- Bulk Upload student-->
    <!-- Modal popup -->
    <div class="modal fade"  id="bulkUploadSTudent" tabindex="-1" role="dialog"
      aria-labelledby="simpleModalLabel" aria-hidden="true" data-backdrop="static">
      <div class="modal-dialog">
        <div class="modal-content col-md-12" style=" padding: 0;">
          <div class="modal-body" style="padding: 0;">
            <div class="loader_import_student" [class.hide]="loaderImportStudent"
              style="position: absolute;width: 100%;left: 0;background: white;padding-bottom: 8em;">
              <div class="col-md-12" style="text-align: center;">
                <img src="assets/img/search_icon_animation.gif" style="   width: 300px;">
                <h3 style="margin: 0;margin-top: -2em;color: #a1a1a1;font-weight: 400;">{{ 'uploadingPleaseWait' | translate }}....</h3>
              </div>
            </div>
            <div [class.hide]="!loaderImportStudent" class="hidden-xs col-md-6 particles-bg "
              style="min-height: 600px;background: var(--secondary-btn-bg-color);">
              <div class="col-md-12 text-center" style="position:absolute;top:9em;">
                <p class="lead text-center"
                  style="color: #ffffff;text-transform: uppercase; letter-spacing: 1px;margin-bottom: 10px;">{{ 'importStudents' | translate }}</p>
                <img src="assets/img/students.png" class="img-responsive" style="margin: 0 auto;">
                <p style="margin: 15px 0px; color: white; font-weight: 100;">{{ 'importStudentDetailsHere' | translate }}</p>
                <p class="lead"
                  style="color: white; font-size: 15px; border: 1px solid;    display: inline-block;    padding: 5px 15px;">
                  {{ 'getStarted' | translate }} &nbsp;&nbsp;&nbsp;<i class="fa fa-chevron-right"></i></p>
                <div class="row">
                  <div class="col-md-12" style="color: white;">
                    <p class="lead" style="font-size: 13px;margin-top: 2em;">{{ 'ifYouHaventTheTemplateForImportTheStudents' | translate }}<br>{{ 'pleaseDownloadItFrom' | translate }} <span><a download="student_bulk_upload_template_sheet.xls"
                          target="_blank"
                          href="https://bluewingsfilestorage.s3.us-west-2.amazonaws.com/BluewingsEnterprise/student_bulk_upload_template_latest.xlsx"
                          style="background: white;color: var(--secondary-btn-bg-color);padding: 0px 2px;font-weight: 500;">{{ 'here' | translate }}</a></span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div [class.hide]="!loaderImportStudent" class="col-md-6">
              <div class="col-md-12 close-btn-container">
                <h3 class="close-modal" data-dismiss="modal" id="bulkUploadSTudentClose"><i
                    class="fa fa-close"></i></h3>
              </div>
              <div class="col-md-12" style="margin-top: -12px">
                <h4>{{ 'thingsToRememberBeforeUploadingStudentsDetails' | translate }}</h4>
                <ul style="list-style: none;font-size: 11px;color: #777777;">
                  <li>{{ '1ImportingFileShouldBeInExcelFileXlsFormat' | translate }}</li>
                  <li>{{ '2CreateExcelFileBasedOnTheFormatGivenByBluewingsAdmin' | translate }}</li>
                  <li>{{ '3DoNotEditTheColumnHeaderTitle' | translate }}</li>
                  <li>{{ '4FieldsClassid,studentname,gender,dob,dateOfAdmission,parentname,parentcontact,parentmailid,admissionidAreMandatory' | translate }}</li>
                  <li>{{ '5FormatOfParentContactShouldBeCountryCode)-(numberI.e123-1234567890' | translate }}</li>
                  <li>{{ '5FormatOfDateShouldBeDd/mm/yyyy' | translate }}</li>
                  <li>{{ '6ExcelSheetBasedOnClassIsRecommended' | translate }}</li>
                  <li>{{ '7ErrorStatusWillBeListedIfAnyAfterUploading' | translate }}</li>
                  <li>{{ '8GenderFieldShouldBeMF' | translate }}</li>
                </ul>
              </div>
              <div class="col-md-12">
                <h4>{{ 'importStudentsBasedOnClass' | translate }}</h4>
                <form class="form">
                  <!--Select Category-->
                  <div class="form-group col-md-12" style="padding: 0px;padding-top: 16px;">
                    <select (change)="importStudentSelectCategory($event.target.value)" id="categoryselect"
                      name="select1" class="form-control" style="color: #6b6b6b;font-size: 12px;">
                      <option value="0" disabled>{{ 'selectClassCategory' | translate }}</option>
                      <option *ngFor="let category of schoolCategories" value="{{category.categoryId}}">
                        {{category.categoryName}}</option>
                    </select>
                    <label for="categoryselect">{{ 'category' | translate }}</label>
                  </div>
                  <!--///////-->
                  <!--Select Class-->
                  <div class="form-group col-md-6" style="padding: 0px;padding-top: 16px;">
                    <select (change)="importStudentSelectClass($event.target.value)" id="classselect" name="select1"
                      class="form-control" style="color: #6b6b6b;font-size: 12px;">
                      <option value="0" disabled>{{ 'selectClass' | translate }}</option>
                      <option *ngFor="let class of getClassInImport" value="{{class.classid}}">{{class.classname}}
                      </option>
                    </select>
                    <label for="classselect">{{ 'class' | translate }}</label>
                  </div>
                  <!--///////-->
                  <!--Select Section-->
                  <div class="form-group col-md-6" style="padding: 0px;padding-top: 16px;">
                    <select (change)="importStudentSelectSection($event.target.value)" id="sectionselect" name="select1"
                      class="form-control" style="color: #6b6b6b;font-size: 12px;">
                      <option value="0" disabled>{{ 'selectClassSection' | translate }}</option>
                      <option *ngFor="let section of getSectionInImport" value="{{section.claaSectionId}}">
                        {{section.classSection}}</option>
                    </select>
                    <label for="sectionselect">{{ 'section' | translate }}</label>
                  </div>
                  <!--//////////-->
                  <div class="form-group col-md-12" style="padding: 0px;">
                    <div class="file-field input-field">
                      <div class="btn">
                        <span style="margin-left: -1em;cursor:default;color: #a5a5a5;text-transform: capitalize;font-weight: 100;">{{ 'file' | translate }}
                          <i class="fa fa-cloud-upload"></i></span>
                        <input (change)="getImportFile($event)" id="studentBulkUploadSelectFile" type="file" class=""
                          style="position: absolute;opacity: 0;cursor:pointer;padding: 0;margin: 0;width: 100%;left: 0;cursor: default;">
                      </div>
                      <div class="file-path-wrapper" disabled="">
                        <input class="file-path" type="text"
                        id="displayFileName"
                          style="margin: 0;width: 100%;background: white; color: #a0a0a0;border: none;border-bottom: 1px solid #e2e2e2;cursor:pointer ;padding: 0;"
                          disabled placeholder="{{'selectFile' | translate}}">
                      </div>
                    </div>
                  </div>
                </form>
                <div class="col-md-12" style="padding: 0;">
                  <button (click)="importStudentProceed()" type="button"
                    class="btn btn-raised ink-reaction btn-info" aria-expanded="false"
                    style="padding: 3px 48px;">{{ 'import' | translate }}</button> 
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /////// -->
    <!-- End -->






    <!-- Menubar -->
    <!--  -->

    <!-- Delete  -->
    <div class="modal fade" id="update-student-rool-number-confirm" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog" style="padding: 10em 0em;">
        <div class="modal-content" style="padding: 1em 0em;border: 10px dashed;">
          <div class="row text-center">
            <h4 #delete_text id="delete_text">{{ 'areYouConfirmToChangeAllStudentRollNumbersToAlphabetOrder' | translate }} </h4>
          </div>
          <div class="text-center" style="padding: 8px 0px;">
            <button id="update-student-rool-number-ok" type="button" class="btn btn-raised ink-reaction btn-info"
              style="padding: 3px 20px;" (click)="updateStudentRollNumberToAlphabetOrder(selectedSection)">{{ 'yes' | translate }}</button>
            <button id="update-student-rool-number-cancel" type="button" class="btn btn-raised ink-reaction btn-info"
              style="padding: 3px 20px;" data-dismiss="modal" aria-hidden="true">{{ 'cancel' | translate }}</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Delete  -->

    <!-- Update Roll Number popup -->
    <p-dialog [(visible)]="showUpdateRollNumberPopup" [modal]="true" [closable]="false" [draggable]="false"
      [resizable]="false" [showHeader]="false" [style]="{ width: '700px' }" class="update-roll-number-dialog"
      (onHide)="closeUpdateRollNumberPopup()">
      <div class="roll-number-header">
        <div class="roll-number-header-text">
          <h3>{{ 'updateRollNumber' | translate }}</h3>
          <span>{{updateRollNumberClassName}}<ng-container *ngIf="updateRollNumberSectionName"> &middot;
              {{updateRollNumberSectionName}}</ng-container> &middot;
            {{updateRollNumberStudentList.length}} {{ 'students' | translate }}</span>
        </div>
        <button type="button" class="roll-number-close-btn" (click)="closeUpdateRollNumberPopup()">
          <i class="pi pi-times"></i>
        </button>
      </div>

      <div class="roll-number-search">
        <i class="pi pi-search"></i>
        <input type="text" [placeholder]="'searchByNameAdmissionNoOrMobile' | translate"
          [(ngModel)]="rollNumberSearchText" [ngModelOptions]="{standalone: true}"
          (ngModelChange)="filterRollNumberStudentList()">
      </div>

      <div class="roll-number-table">
        <div class="roll-number-columns">
          <span class="roll-number-col roll-number-col-student">{{ 'student' | translate }}</span>
          <span class="roll-number-col roll-number-col-admission">{{ 'admission' | translate }}</span>
          <span class="roll-number-col roll-number-col-roll">{{ 'roll' | translate }}</span>
        </div>

        <div class="roll-number-list">
          <ng-container *ngIf="updateRollNumberLoading">
            <div class="roll-number-row roll-number-skeleton-row" *ngFor="let skeleton of generateDummyArray(5)">
              <div class="roll-number-student-cell">
                <p-skeleton shape="circle" size="42px"></p-skeleton>
                <div class="roll-number-student-details">
                  <p-skeleton width="140px" height="14px"></p-skeleton>
                  <p-skeleton width="110px" height="11px"></p-skeleton>
                  <p-skeleton width="110px" height="11px"></p-skeleton>
                </div>
              </div>
              <p-skeleton width="70px" height="14px"></p-skeleton>
              <p-skeleton width="60px" height="40px"></p-skeleton>
            </div>
          </ng-container>
          <ng-container *ngIf="!updateRollNumberLoading">
            <div class="roll-number-row" *ngFor="let student of filteredRollNumberStudentList; let i = index">
              <div class="roll-number-student-cell">
                <img *ngIf="student.studentImage" class="roll-number-avatar-img" [src]="student.studentImage"
                  alt="{{student.studentName}}">
                <div *ngIf="!student.studentImage" class="roll-number-avatar"
                  [ngClass]="'roll-number-avatar-' + (i % 5)">
                  {{getStudentInitials(student.studentName)}}</div>
                <div class="roll-number-student-details">
                  <span class="roll-number-student-name">{{student.studentName}}</span>
                  <span class="roll-number-student-meta">{{ 'father' | translate }}: {{student.fatherName}}</span>
                  <span class="roll-number-student-meta">{{ 'mobile' | translate }}: {{student.mobileNumber}}</span>
                </div>
              </div>
              <span class="roll-number-admission">{{student.admissionNumber}}</span>
              <input type="text" class="roll-number-input"
                [class.roll-number-input-invalid]="!student.rollNumber" [(ngModel)]="student.rollNumber"
                [ngModelOptions]="{standalone: true}" (keydown)="handleKeyDown($event)"
                (paste)="sanitizeRollNumberOnPaste($event, student)" maxlength="4">
            </div>
            <div *ngIf="filteredRollNumberStudentList.length === 0" class="update-roll-number-empty">
              {{ 'thereAreNoStudentsAvailable' | translate }}
            </div>
          </ng-container>
        </div>
      </div>

      <div class="roll-number-footer">
        <div class="roll-number-hint" [class.roll-number-hint-error]="hasEmptyRollNumber()">
          <i class="pi" [ngClass]="hasEmptyRollNumber() ? 'pi-exclamation-circle' : 'pi-info-circle'"></i>
          <span *ngIf="!hasEmptyRollNumber()">{{ 'tapARollNumberToEditIt' | translate }}</span>
          <span *ngIf="hasEmptyRollNumber()">{{ 'rollNumberCannotBeEmpty' | translate }}</span>
        </div>
        <div class="roll-number-actions">
          <button type="button" class="roll-number-btn roll-number-btn-secondary" [disabled]="savingRollNumbers"
            (click)="closeUpdateRollNumberPopup()">{{ 'cancel' | translate }}</button>
          <button type="button" class="roll-number-btn roll-number-btn-primary"
            [disabled]="savingRollNumbers || hasEmptyRollNumber()" (click)="saveRollNumbers()">
            <app-button-loader *ngIf="savingRollNumbers" [borderStyle]="'3px solid #ffffff'"></app-button-loader>
            <span *ngIf="!savingRollNumbers">{{ 'saveChanges' | translate }}</span>
          </button>
        </div>
      </div>
    </p-dialog>
    <!-- Update Roll Number popup End -->

    <div class="offcanvas">

      <!-- Import Students off canvas -->
      <div id="import-student-canvas" class="offcanvas-pane width-12" style="width:1200px;overflow-x: hidden;">
        <div class="modal-body" style="padding: 0;">
          <div class="col-md-12 particles-bg1" style="min-height: 240px;background: var(--secondary-btn-bg-color);">
            <div class="col-md-12" style="position: absolute;z-index: 999;top: -1em;color: white;left: 0;">
              <h3 class="pull-right" style="cursor: pointer;" data-dismiss="offcanvas"><i class="fa fa-close"></i></h3>
            </div>
            <div class="col-md-12 text-center" style="position:absolute;top:1em;">
              <p class="lead text-center"
                style="color: #ffffff;text-transform: uppercase; letter-spacing: 1px;margin-bottom: 10px;">{{ 'importedStudents' | translate }}</p>
              <img src="assets/img/students.png" class="img-responsive" style="margin: 0 auto;width:75px;">
              <p class="lead" style="font-size: 13px;color: white;    margin: 20px 0px;">{{ 'pleaseVerifyTheDataAndCorrectTheErrorsBeforeProceeding' | translate }}</p>
              <p class="lead"
                style="color: white;font-size: 15px;border: 1px solid;display: inline-block;padding: 5px 15px;">{{ 'verifyTheData' | translate }} &nbsp;&nbsp;&nbsp;<i class="fa fa-chevron-down"></i></p>
            </div>
          </div>

          <div class="col-md-12" style="min-height: 630px;">
            <div class="row" style="background: #f1f1f1;margin-bottom: 2em;">
              <div class="col-md-12">
                <h4 class="lead pull-left"
                  style="margin: 10px 10px;color: #888888;letter-spacing: 1px;font-size: 14px;text-transform: uppercase;">
                  {{ 'importedStudentList' | translate }}</h4>
              </div>
              <div class="loader_import_student" [class.hide]="loaderImportStudent"
                style="position: absolute;width: 100%;height: 100%;left: 0;background: white;padding-bottom: 8em;z-index: 999;margin-top: 5em;">
                <div class="col-md-12" style="text-align: center;">
                  <img src="assets/img/search_icon_animation.gif" style="   width: 300px;">
                  <h3 style="margin: 0;margin-top: -2em;color: #a1a1a1;font-weight: 400;">{{ 'pleaseWait' | translate }}</h3>
                </div>
              </div>
            </div>
            <div class="table-responsive" style="margin-top: 2em;">
              <table id="new-admission-import-table" class="display" cellspacing="0" width="100%">
                <thead>
                  <tr>
                    <th style="padding-left: 15px;">{{ 'studentclassid' | translate }}</th>
                    <th style="padding-left: 15px;">{{ 'studentname' | translate }}</th>
                    <th style="padding-left: 15px;">{{ 'dateofbirthData' | translate }}</th>
                    <th style="padding-left: 15px;">{{ 'studentgender' | translate }}</th>
                    <th style="padding-left: 15px;">{{ 'admissionid' | translate }}</th>
                    <th style="padding-left: 15px;">{{ 'dateofadmission' | translate }}</th>
                    <th style="padding-left: 15px;">{{ 'parentname' | translate }}</th>
                    <th style="padding-left: 15px;">{{ 'parentcontactnumber' | translate }}</th>
                    <th style="padding-left: 15px;">{{ 'parentemail' | translate }}</th>
                        <th style="padding-left: 15px;">{{ 'countryCodeData' | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let student of importStudentListArray" class="gradeX">
                    <td class="import-students-classids" style="font-weight: 400;color: #828282;"
                      [class.import-error]="student.studentClassIdStatus == '1'" name="classid">
                      {{trimData(student.studentClassId)}}</td>
                    <td style="font-weight: 400;color: #828282;" [class.import-error]="student.studentNameStatus == '1'"
                      name="name">{{trimData(student.studentName)}}</td>
                    <td style="font-weight: 400;color: #828282;" [class.import-error]="student.dateOfBirthStatus == '1'"
                      name="dob">{{trimData(student.dateOfBirth)}}</td>
                    <td style="font-weight: 400;color: #828282;"
                      [class.import-error]="student.studentGenderStatus == '1'" name="gender">{{trimData(student.studentGender)}}</td>
                    <td style="font-weight: 400;color: #828282;" [class.import-error]="student.admissionIdStatus == '1'"
                      name="admissionid">{{trimData(student.admissionId)}}</td>
                    <td style="font-weight: 400;color: #828282;"
                      [class.import-error]="student.dateOfAdmissionStatus == '1'" name="admissiondate">
                      {{trimData(student.dateOfAdmission)}}</td>
                    <td style="font-weight: 400;color: #828282;" [class.import-error]="student.parentNameStatus == '1'"
                      name="parentname">{{trimData(student.parentName)}}</td>
                    <td style="font-weight: 400;color: #828282;"
                      [class.import-error]="student.parentContactNumberStatus == '1'" name="parentcontact">
                      {{trimData(student.parentContactNumber)}}</td>
                    <td style="font-weight: 400;color: #828282;" [class.import-error]="student.parentEmailStatus == '1'"
                      name="parentemail">{{trimData(student.parentEmail)}}</td>
                      <td style="font-weight: 400;color: #828282;" [class.import-error]="student.countryCodeStatus == '1'"
                      name="CountryCode">{{trimData(student.countryCode)}}</td>
                  </tr>
                </tbody>
              </table>
            </div><!--end .table-responsive -->
            <p class="hide get-json-value"></p>
            <div class="col-md-12"
              style="margin-bottom: 2em;margin-top: 10px;text-align: center;background: whitesmoke;padding-top: 10px;padding-bottom: 15px;border: 1px solid #e2e2e2;">
              <p class="lead" style="margin-bottom: 3px;">{{ 'resolveTheErrorsAndProceed' | translate }}</p>
              <p>{{ 'errorFieldsWillShowsInRedIfThereIsNoErrorProceedOtherwiseResolveTheErrors' | translate }}</p>
              <button type="button" class="btn ink-reaction btn-raised btn-default-bright"
                style="margin: 0px 5px;width: 300px;padding: 8px 0px;" (click)="resolveErrors()">{{ 'resolveError' | translate }}</button>
              <button type="button" class="proceed-import btn ink-reaction btn-raised btn-info resolve-proceed-data1"
                style="background: var(--secondary-btn-bg-color);border: var(--secondary-btn-bg-color);margin: 0px 5px;width: 300px;padding: 8px 0px;"
                (click)="resolveErrorsProceedData()">{{ 'proceedData' | translate }}</button>
              <button type="button" class="proceed-import btn ink-reaction btn-raised btn-info resolve-proceed-data2"
                style="background: var(--secondary-btn-bg-color);border: var(--secondary-btn-bg-color);margin: 0px 5px;width: 300px;padding: 8px 0px;display:none;"
                (click)="validateImportStudentByDuplicate()">{{ 'proceedData' | translate }}</button>
            </div>
          </div>
        </div>
      </div>
      <!-- END Import Students off canvas -->


      <!-- Start Off canvas student section -->
      <!--Add new student-->
      <div id="offcanvas-add-newstudent" class="offcanvas-pane width-12" style="width:1000px;    overflow-x: hidden;">
        <div class="offcanvas-head" style="padding: 0;">
          <!-- Student details -->
          <div id="particles-add-students" class="row" style="background: var(--secondary-btn-bg-color);min-height: 250px;">
            <div class="particles-content">
              <div class="col-md-12" style="position: fixed;z-index: 999;top: 0em;">
                <h3 id="addStClose" class="pull-right" style="color: white;cursor: pointer;" data-dismiss="offcanvas"><i
                    class="fa fa-close"></i></h3>
              </div>
              <div class="col-md-12 text-center">
                <p class="lead text-center"
                  style="color: #ffffff;text-transform: uppercase; letter-spacing: 1px;margin-bottom: 10px;">{{ 'addStudent' | translate }}
                </p>
                <img src="assets/img/student-avatar.png" class="img-responsive" style="margin: 0 auto;width: 75px;">
                <p style="margin: 15px 0px; color: white; font-weight: 100;">{{ 'addNewStudentDetailsHere' | translate }}</p>
              </div>
            </div>
          </div>
          <div class="row" style="background: #f1f1f1;">
            <div class="col-md-12">
              <h4 class="lead pull-left"
                style="margin: 10px 10px;color: #888888;letter-spacing: 1px;font-size: 12px;text-transform: uppercase;">
                {{ 'fillStudentDetails' | translate }}</h4>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <form class="form">
                <!-- Basic info //////////////// -->
                <div class="row" style="background: white;margin: 15px 0px;margin-top: 25px;">
                  <div class="col-md-12">
                    <p class="pull-left text-lg"
                      style="position: relative;background: #888888;color: white;padding: 0px 10px;box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.33);margin-right: 10px;">
                      1</p>
                    <h4 style="padding: 10px 10px;margin-top: 0;font-weight: 400;color: #888888;">
                      {{ 'studentBasicInfo' | translate }}
                    </h4>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <input (change)="addNewStudentNameOnchange(addNewStudentName)" [(ngModel)]="addNewStudentName"
                        [ngModelOptions]="{standalone: true}" type="text" class="form-control addStudentChange"
                        id="admission-student-name">
                      <label for="admission-student-name">{{ 'studentName' | translate }}<span style="color: #F44336;">*</span></label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <input (change)="addNewStudentSurNameOnchange()" [(ngModel)]="addNewStudentSurName"
                        [ngModelOptions]="{standalone: true}" type="text" class="form-control changeSurName"
                        id="admission-surname">
                      <label for="admission-surname">{{ 'surname' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <select (change)="addNewStudentGenderOnchange()" [(ngModel)]="addNewStudentGender"
                        [ngModelOptions]="{standalone: true}" id="admission-gender-groups" name="gender"
                        class="form-control changeGender"
                        style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                        <option value="1">{{ 'male' | translate }}</option>
                        <option value="0">{{ 'female' | translate }}</option>
                      </select>
                      <label for="admission-gender-groups">{{ 'gender' | translate }}<span style="color: #F44336;">*</span></label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <input (change)="addNewStudentDobOnchange()" [(ngModel)]="addNewStudentDOB"
                        [ngModelOptions]="{standalone: true}" type="text"
                        class="form-control addNewStudentDOB changestudDob applyPicker" id="admission-dob"
                        style="text-transform: initial;" data-provide="datepicker" data-date-format="dd/mm/yyyy"
                        data-date-end-date="0d">
                      <label for="admission-dob">{{ 'dateOfBirth' | translate }}<span style="color: #F44336;">* </span> {{ 'dd/mm/yyyy' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <select (change)="addNewStudentBloodGrpOnchange()" [(ngModel)]="addNewStudentBloodGroup"
                        [ngModelOptions]="{standalone: true}" id="admission-blood-group" name="select1"
                        class="form-control changeBloodgroup"
                        style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                        <option value="A+">{{ 'a+' | translate }}</option>
                        <option value="A-">{{ 'a-' | translate }}</option>
                        <option value="B+">{{ 'b+' | translate }}</option>
                        <option value="B-">{{ 'b-' | translate }}</option>
                        <option value="AB+">{{ 'ab+' | translate }}</option>
                        <option value="AB-">{{ 'ab-' | translate }}</option>
                        <option value="O+">{{ 'o+' | translate }}</option>
                        <option value="O-">{{ 'o-' | translate }}</option>
                      </select>
                      <label for="admission-blood-group">{{ 'bloodGroup' | translate }}<span style="color: #F44336;">*</span></label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <select [(ngModel)]="addNewStudentReligion" [ngModelOptions]="{standalone: true}"
                        id="admission-religion" name="select1" class="form-control"
                        style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                        <option value="Hindu">{{ 'hindu' | translate }}</option>
                        <option value="Christian">{{ 'christian' | translate }}</option>
                        <option value="Muslim">{{ 'muslim' | translate }}</option>
                        <option value="Other">{{ 'other' | translate }}</option>
                      </select>
                      <label for="admission-religion">{{ 'religion' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <select [(ngModel)]="addNewStudentCaste" id="admission-caste-category" name="selectCaste"
                        class="form-control"
                        style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                        <option value="General">{{ 'general' | translate }}</option>
                        <option value="OBC">{{ 'obc' | translate }}</option>
                        <option value="ST">{{ 'st' | translate }}</option>
                        <option value="SC">{{ 'sc' | translate }}</option>
                      </select>
                      <label for="admission-cast">{{ 'casteCategory' | translate }}</label>
                    </div>
                  </div>

                  <div class="col-md-3  ">
                    <div class="form-group image-container">
                      <img src="" id="new-student-caste-image-ele" class="add-student-aadhar-image"
                        style="width: 63px;height: 40px;margin-top: 6px;">
                      <i class="fas fa-file-pdf hide" id="caste-pdf-icon" style="margin-left: 10px; width: 63px; height: 40px; margin-top: 3px;  color: red;
font-size: 39px;"></i>
                      <button id="new-student-caste-copy-button" (click)="openNewStudentCasteCopyUpload()"
                        class="btn-raised ink-reaction form-control upload-button">{{ 'upload' | translate }}</button>
                      <input (change)="startUploadingNewCasteCopy()" type="file" class="form-control hide image-input"
                        id="new-student-caste-copy">
                      <label for="admission-phone-number">{{ 'casteCategoryCopy' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <select (change)="addNewStudentNationalityOnchange()" [(ngModel)]="addNewStudentNationality"
                        [ngModelOptions]="{standalone: true}" id="admission-nationality" name="select1"
                        class="form-control changeNationality"
                        style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                        <option *ngFor="let nationality of (nationalityData?.[0] || [])" [value]="nationality.name">
                          {{nationality.name}}</option>
                      </select>
                      <label for="admission-nationality">{{ 'nationality' | translate }}<span style="color: #F44336;">*</span></label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <input (change)="addNewStudentEmailOnchange()" type="text" [(ngModel)]="addNewStudentEmail"
                        [ngModelOptions]="{standalone: true}" class="form-control changeEmail"
                        id="admission-student-email">
                      <label for="admission-student-email">{{ 'studentEmail' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <input type="text" [placeholder]="'enterContactNumber' | translate" id="add-student-mobile-number"
                        [ngModelOptions]="{standalone: true}" class="form-control changeMobNo" [ngClass]="{
                          'add-student-contact-field': !invalidAddStudentMobileNumber,
                          'add-student-contact-field-error': invalidAddStudentMobileNumber
                        }" #addStudentMobileNumber
                        (input)="handleDebounceAddStudentMobileNumber(addStudentMobileNumber)"
                        (keydown)="handleKeyDown($event)" autocomplete="off" [(ngModel)]="addNewStudentNumberInput"
                        maxlength="20" />
                      <label for="admission-phone-number">{{ 'contactNumber' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-3" *ngIf="houseNameList.length > 0">
                    <div class="form-group">
                      <select [(ngModel)]="addNewStudentHouseName" id="admission-student-housename"
                        name="admission-student-housename" class="form-control"
                        style="text-transform: uppercase;border: 1px solid #e2e2e2;">
                        <option [value]="null">{{ 'none' | translate }}</option>
                        <option *ngFor="let house of houseNameList" [value]="house.houseName">{{house.houseName}}
                        </option>
                      </select>
                      <label for="admission-student-housename" style="margin-top: -8px;">{{ 'houseName' | translate }}</label>
                    </div>
                  </div>
                  <!-- New Fields -->
                  <div class="col-md-3">
                    <div class="form-group">
                      <input [(ngModel)]="addNewStudentPENNumber" [ngModelOptions]="{standalone: true}"
                        class="form-control changePENNo" id="admission-pen-number" maxlength="12" type="text"
                        (keydown)="handleKeyDown($event)">
                      <label for="admission-pen-number">{{ 'permanentEducationalNumber(pen' | translate }} </label>
                    </div>
                  </div>

                  <!-- New Fields End -->
                  <div class="col-md-3">
                    <div class="form-group">
                      <input name="aadharNumAddStd" [(ngModel)]="addNewStudentAadharNumber"
                        id="add-student-aadharNumber-std" (keyup)="onChangeAadharNum('#add-student-aadharNumber-std')"
                        type="text" class="form-control" maxlength="12">
                      <label for="add-student-aadharNumber-std">{{ 'aadhar(uidNumber' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group" style="display: flex;">
                      <div class="col-md-12 hide" style="text-align:center;" id="new-student-aadhar-progressbar-div">
                        <h5 class="progress" id="new-addmission-student-aadhar-progressbar"
                          style="text-align: center;cursor: pointer;display: inline-block;border: 1px solid #e2e2e2;padding: 9px 0px;margin: 1em -2em;color: var(--secondary-btn-bg-color);font-size: 9px;text-transform: uppercase;width: 150px;">
                          {{ 'uploading' | translate }}</h5>
                      </div>
                      <!-- <img src="" id="new-student-aadhar-image-ele" class="hide"
                        style="width: 63px;height: 40px;margin-top: 6px;"> -->

                      <img src="" id="new-student-aadhar-image-ele" class="add-student-aadhar-image"
                        style="width: 63px;height: 40px;margin-top: 6px;">
                      <i class="fas fa-file-pdf hide" id="aadhar-pdf-icon" style="margin-left: 10px; width: 63px; height: 40px; margin-top: 3px;  color: red;
    font-size: 39px;"></i>
                      <button id="new-student-aadhar-copy-button" style="margin-top: 5px;margin-left: 1px"
                        (click)="openNewStudentAadharCopyUpload()"
                        class="btn-raised ink-reaction form-control">{{ 'upload' | translate }}</button>
                      <input (change)="startUploadingNewStudentAadharCopy($event)" style="width: 1px;height: 1px"
                        type="file" class="form-control hide" id="new-student-aadhar-copy">
                      <label for="admission-phone-number">{{ 'aadharCopy' | translate }}</label>
                    </div>
                  </div>

                  <!-- TC OR Birth Certificate -->
                  <div class="col-md-3">
                    <div class="form-group" style="display: flex;">
                      <div class="col-md-12 hide" style="text-align:center;"
                        id="new-student-tc-or-birth-certificate-progressbar-div">
                        <h5 class="progress" id="new-addmission-student-tc-or-birth-certificate-progressbar"
                          style="text-align: center;cursor: pointer;display: inline-block;border: 1px solid #e2e2e2;padding: 9px 0px;margin: 1em -2em;color: var(--secondary-btn-bg-color);font-size: 9px;text-transform: uppercase;width: 150px;">
                          {{ 'uploading' | translate }}</h5>
                      </div>

                      <!-- <img src="" id="new-student-tc-or-birth-image-ele" class="hide"
                        style="width: 63px;height: 40px;margin-top: 6px;"> -->


                      <img src="" id="new-student-tc-or-birth-image-ele" class="add-student-aadhar-image"
                        style="width: 63px;height: 40px;margin-top: 6px;">
                      <i class="fas fa-file-pdf hide" id="tc-or-birth-pdf-icon" style="margin-left: 10px; width: 63px; height: 40px; margin-top: 3px;  color: red;
  font-size: 39px;"></i>
                      <button id="new-student-tc-or-birth-copy-button" style="margin-top: 5px;margin-left: 1px"
                        (click)="openNewStudentTcOrBirthCopyUpload()"
                        class="btn-raised ink-reaction form-control">{{ 'upload' | translate }}</button>
                      <input (change)="startUploadingNewTcOrBirthCopy()" style="width: 1px;height: 1px" type="file"
                        class="form-control hide" id="new-student-tc-or-birth-copy">
                      <label for="new-student-tc-or-birth-copy">{{ 'tcBirthCertificate' | translate }}</label>
                    </div>


                  </div>
                </div>
                <div class="col-md-3">
                  <div class="input-check-box-container">
                    <input [(ngModel)]="addNewIsMinority" [ngModelOptions]="{standalone: true}"
                      class="check-box-input-filed" id="admission-minority" type="checkbox">
                    <label for="admission-minority" class="label-input-check-box">{{ 'minority' | translate }} </label>
                  </div>
                </div>
                <!-- whether the candidate is  -->
                <div class="row" style="background: white;margin: 15px 0px;margin-top: 25px;">
                  <div class="col-md-12">
                    <p class="pull-left text-lg"
                      style="position: relative;background: #888888;color: white;padding: 0px 10px;box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.33);margin-right: 10px;">
                      2</p>
                    <h4 style="padding: 10px 10px;margin-top: 0;font-weight: 400;color: #888888;">{{ 'whetherTheCandidateIs' | translate }} </h4>
                  </div>


                  <div class="col-md-12">
                    <div class="col-md-6">
                      <div class="input-check-box-container">
                        <input class="check-box-input-filed" id="admission-specially-abled" type="checkbox"
                          [ngModelOptions]="{standalone: true}" [(ngModel)]="addNewStudentIsSpeciallyDisabled">
                        <label class="label-input-check-box">{{ 'speciallyAbledDivyangjan' | translate }} </label>
                      </div>
                    </div>

                    <div class="col-md-3 " *ngIf="addNewStudentIsSpeciallyDisabled">
                      <div class="form-group image-container">
                        <img src="" id="new-student-Divyangjan-image-ele" class="add-student-aadhar-image hide"
                          style="width: 63px;height: 40px;margin-top: 6px;">
                        <i class="fas fa-file-pdf hide" id="divyangjan-pdf-icon" style="margin-left: 10px; width: 63px; height: 40px; margin-top: 3px;  color: red;
  font-size: 39px;"></i>
                        <button id="new-student-Divyangjan-copy-button" (click)="openNewStudentDivyangjanCopyUpload()"
                          class="btn-raised ink-reaction form-control upload-button">{{ 'upload' | translate }}</button>
                        <input (change)="startUploadingNewDivyangjanCopy()" type="file"
                          class="form-control hide image-input" id="new-student-Divyangjan-copy">
                        <label for="admission-phone-number">{{ 'divyangjanCopy' | translate }}</label>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12" *ngIf="addNewStudentGender === '0'">
                    <div class="col-md-6">
                      <div class="input-check-box-container">
                        <input class="check-box-input-filed" id="admission-single-girl-child" type="checkbox"
                          [ngModelOptions]="{standalone: true}" [(ngModel)]="addNewStudentIsSingleGirlChild">
                        <label for="admission-single-girl-child" class="label-input-check-box">{{ 'singleGirlChild' | translate }}
                        </label>
                      </div>
                    </div>

                    <div class="col-md-3 " *ngIf="addNewStudentIsSingleGirlChild">
                      <div class="form-group image-container">

                        <img src="" id="new-student-single-girl-image-ele" class="add-student-aadhar-image hide"
                          style="width: 63px;height: 40px;margin-top: 6px;">
                        <i class="fas fa-file-pdf hide" id="single-girl-pdf-icon" style="margin-left: 10px; width: 63px; height: 40px; margin-top: 3px;  color: red;
font-size: 39px;"></i>

                        <button id="new-student-single-girl-copy-button" (click)="openNewStudentSingleGirlCopyUpload()"
                          class="btn-raised ink-reaction form-control upload-button">{{ 'upload' | translate }}</button>
                        <input (change)="startUploadingNewSingleGirlCopy()" type="file"
                          class="form-control hide image-input" id="new-student-single-girl-copy">
                        <label for="admission-phone-number">{{ 'singleGirlChildCopy' | translate }}</label>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12" *ngIf="addNewStudentCaste === 'General'">
                    <div class="col-md-6">
                      <div class="input-check-box-container">
                        <input class="check-box-input-filed" id="admission-ews" type="checkbox"
                          [ngModelOptions]="{standalone: true}" [(ngModel)]="addNewStudentIsEWS">
                        <label for="admission-ews" class="label-input-check-box">{{ 'belongingToEwsEconomicallyWeakerSection' | translate }}</label>
                      </div>
                    </div>

                    <div class="col-md-3" *ngIf="addNewStudentIsEWS">
                      <div class="form-group image-container">
                        <img src="" id="new-student-EWS-image-ele" class="add-student-aadhar-image hide"
                          style="width: 63px;height: 40px;margin-top: 6px;">
                        <i class="fas fa-file-pdf hide" id="EWS-pdf-icon" style="margin-left: 10px; width: 63px; height: 40px; margin-top: 3px;  color: red;
font-size: 39px;"></i>
                        <button id="new-student-EWS-copy-button" (click)="openNewStudentEWSCopyUpload()"
                          class="btn-raised ink-reaction form-control upload-button">{{ 'upload' | translate }}</button>
                        <input (change)="startUploadingNewEWSCopy()" type="file" class="form-control hide image-input"
                          id="new-student-EWS-copy">
                        <label for="admission-phone-number">{{ 'ewsCopy' | translate }}</label>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Admission details//////////// -->
                <div class="row" style="background: white;margin: 15px 0px;margin-top: 25px;">
                  <div class="col-md-12">
                    <p class="pull-left text-lg"
                      style="position: relative;background: #888888;color: white;padding: 0px 10px;box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.33);margin-right: 10px;">
                      3</p>
                    <h4 style="padding: 10px 10px;margin-top: 0;font-weight: 400;color: #888888;">{{ 'admissionDetails' | translate }}</h4>
                  </div>


                  <div class="col-md-4">
                    <div class="form-group">
                      <select [(ngModel)]="addNewStudentAdmissionBase" [ngModelOptions]="{standalone: true}"
                        id="admission-base" name="select1" class="form-control"
                        style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                        <option value="Written exam">{{ 'writtenExam' | translate }}</option>
                        <option value="Interview">{{ 'interview' | translate }}</option>
                      </select>
                      <label for="admission-base">{{ 'admissionBase' | translate }}<span style="color: #F44336;">*</span></label>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <select [(ngModel)]="addNewStudentAdmissionStream" [ngModelOptions]="{standalone: true}"
                        id="admission-stream" name="select1" class="form-control"
                        style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                        <option value="general">{{ 'generalDefault' | translate }}</option>
                        <option *ngFor="let o of studentCategoryListForAdmission" [value]="o.pkStudentsCategoryId">
                          {{o.Name}}</option>
                      </select>
                      <label for="admission-stream">{{ 'feesCategory' | translate }}<span style="color: #F44336;">*</span></label>
                    </div>
                  </div>
                  <div class="col-md-4" *ngIf="generateStudentRegistrationId == 'MANUAL'">
                    <div class="form-group">
                      <input (change)="addNewStudentAdmissionNumberOnchange()"
                        [(ngModel)]="addNewStudentAdmissionNumber" [ngModelOptions]="{standalone: true}" type="text"
                        class="form-control changeAdmsnNo" id="admission-num">
                      <label for="regular2">{{ 'admissionNumber' | translate }}<span style="color: #F44336;">*</span><span
                          class="last_registration_number"></span></label>
                    </div>
                  </div>
                  <div class="col-md-4 invisible" *ngIf="generateStudentRegistrationId == 'AUTO'">
                    <div class="form-group">
                      <input type="text" class="form-control changeAdmsnNo">
                      <label for="regular2">{{ 'admissionNumber' | translate }}<span style="color: #F44336;">*</span><span
                          class="last_registration_number"></span></label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <select name="admissioncat" class="form-control changeCat" style="text-transform: uppercase;"
                        (change)="selectcategoryFunctionAdd($event.target.value);addNewStudentChangeCategory()"
                        id="admissioncat">
                        <option value="">{{ 'selectCategory' | translate }}</option>
                        <option *ngFor="let category of schoolCategories" value="{{category.categoryId}}">
                          {{category.categoryName}}</option>
                      </select>
                      <label for="admissioncat">{{ 'category' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <select name="admissionsclass" class="form-control changeClass" style="text-transform: uppercase;"
                        (change)="selectclassFunctionAdd($event.target.value);addNewStudentChangeClass()"
                        id="admissionsclass">
                        <option value="">{{ 'selectClass' | translate }}</option>
                        <option *ngFor="let class of schoolClassesAdd" value="{{class.classid}}">{{class.classname}}
                        </option>
                      </select>
                      <label for="admissionsclass">{{ 'class' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <select (change)="addNewStudentChangeClassSection()" [(ngModel)]="addNewStudentClassId"
                        [ngModelOptions]="{standalone: true}" id="admission-classId" name="admission-classId"
                        class="form-control changeSection" style="text-transform: uppercase;">
                        <option value="0">{{ 'selectSection' | translate }}</option>
                        <option *ngFor="let section of schoolClassesSectionsAdd" value="{{section.claaSectionId}}">
                          {{section.classSection}}</option>
                      </select>
                      <label for="admission-classId">{{ 'section' | translate }}</label>
                    </div>
                  </div>
                </div>
                <!-- Parent info/////////////////// -->
                <div class="row" style="background: white;margin: 15px 0px;margin-top: 25px;">
                  <div class="col-md-12">
                    <p class="pull-left text-lg"
                      style="position: relative;background: #888888;color: white;padding: 0px 10px;box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.33);margin-right: 10px;">
                      4</p>
                    <h4 style="padding: 10px 10px;margin-top: 0;font-weight: 400;color: #888888;">{{ 'parentsDetails' | translate }}</h4>
                  </div>
                  <div class="row" style="margin: 0;">
                    <div class="col-md-12">
                      <h5 style="margin-top: 0;">{{ 'fathersInfo' | translate }}</h5>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <input (change)="addNewStudentFatherNameOnchange()" [(ngModel)]="addNewStudentFatherName"
                          [ngModelOptions]="{standalone: true}" type="text" class="form-control changeFatherName"
                          id="admission-father-name">
                        <label for="admission-father-name">{{ 'fathersName' | translate }}<span style="color: #F44336;">*</span></label>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group parentDetail">
                        <input type="text" [placeholder]="'enterContactNumber' | translate" id="add-student-father-mobile-number"
                          [ngModelOptions]="{standalone: true}" class="form-control" [ngClass]="{
                            'add-student-contact-field': !invalidAddStudentFatherMobileNumber,
                            'add-student-contact-field-error': invalidAddStudentFatherMobileNumber
                          }" #addStudentFatherMobileNumber
                          (input)="handleDebounceAddStudentFatherMobileNumber(addStudentFatherMobileNumber)"
                          (keydown)="handleKeyDown($event)" autocomplete="off"
                          [(ngModel)]="addStudentFatherMobileNumberInput" maxlength="20" />
                        <label for="regular2">{{ 'contactNumber' | translate }}<span style="color: #F44336;">*</span></label>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <select [(ngModel)]="addNewStudentFatherOccupation" [ngModelOptions]="{standalone: true}"
                          id="admission-father-occupation" name="select1" class="form-control"
                          style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                          <option value="0"></option>
                          <option value="Agriculture, Food and Natural Resources">{{ 'agricultureFoodAndNaturalResources' | translate }}</option>
                          <option value="Architecture and Construction">{{ 'architectureAndConstruction' | translate }}</option>
                          <option value="Arts, Audio/Video Technology and Communications">{{ 'artsAudio/videoTechnologyAndCommunications' | translate }}</option>
                          <option value="Business Management and Administration">{{ 'businessManagementAndAdministration' | translate }}
                          </option>
                          <option value="Education and Training">{{ 'educationAndTraining' | translate }}</option>
                          <option value="Finance">{{ 'finance' | translate }}</option>
                          <option value="Government and Public Administration">{{ 'governmentAndPublicAdministration' | translate }}
                          </option>
                          <option value="Health Science">{{ 'healthScience' | translate }}</option>
                          <option value="Hospitality and Tourism">{{ 'hospitalityAndTourism' | translate }}</option>
                          <option value="Human Services">{{ 'humanServices' | translate }}</option>
                          <option value="Information Technology">{{ 'informationTechnology' | translate }}</option>
                          <option value="Law, Public Safety, Corrections and Security">{{ 'lawPublicSafetyCorrectionsAndSecurity' | translate }}</option>
                          <option value="Manufacturing">{{ 'manufacturing' | translate }}</option>
                          <option value="Marketing, Sales and Service">{{ 'marketingSalesAndService' | translate }}</option>
                          <option value="Science, Technology, Engineering and Mathematics">{{ 'scienceTechnologyEngineeringAndMathematics' | translate }}</option>
                          <option value="Transportation, Distribution and Logistics">{{ 'transportationDistributionAndLogistics' | translate }}</option>
                          <option value="Others">{{ 'others' | translate }}</option>
                        </select>
                        <label for="admission-father-occupation">{{ 'occupation' | translate }}</label>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <input (change)="addNewStudentFatherQualificationOnchange()"
                          [(ngModel)]="addNewStudentFatherQualification" [ngModelOptions]="{standalone: true}"
                          type="text" class="form-control changeFatherQuali" id="fatherquali">
                        <label for="regular2">{{ 'educationalQualification' | translate }}</label>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <input type="text" class="form-control" id="father-annual-income"
                          [(ngModel)]="addNewStudentFatherAnnualIncome" [ngModelOptions]="{standalone: true}"
                          (keydown)="handleKeyDown($event)">
                        <label for="regular2">{{ 'annualIncome' | translate }}</label>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="form-group">
                        <input [(ngModel)]="addNewFatherPinCode" [ngModelOptions]="{standalone: true}"
                          class="form-control" id="father-pincode" maxlength="6" type="text"
                          (keydown)="handleKeyDown($event)">
                        <label for="admission-pincode">{{ 'pinCode' | translate }} </label>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="form-group">
                        <input (change)="addFatherEmailOnchange()" type="text" [(ngModel)]="addNewFatherEmail"
                          [ngModelOptions]="{standalone: true}" class="form-control changeFatherEmail" id="admission-father-email">
                        <label for="admission-father-email">{{ 'fatherEmail' | translate }}</label>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-group">
                        <textarea (change)="addNewStudentFatherAddressOnchange()"
                          [(ngModel)]="addNewStudentFatherAddress" [ngModelOptions]="{standalone: true}"
                          name="textarea1" id="admission-father-address" class="form-control changeFatherAdd" rows="3"
                          style="text-transform: initial;border: 1px solid #e8e8e8;padding: 12px 10px;margin-top: 5px;"></textarea>
                        <label for="staddress">{{ 'contactAddress' | translate }}<span style="color: #F44336;">*</span></label>
                      </div>
                    </div>
                  </div>
                  <div class="row" style="margin: 0;">
                    <div class="col-md-12">
                      <h5 style="margin-top: 0;">{{ 'mothersInfo' | translate }}</h5>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <input (change)="addNewStudentMotherNameOnchange()" [(ngModel)]="addNewStudentMotherName"
                          [ngModelOptions]="{standalone: true}" type="text" class="form-control changeMotherName"
                          id="admission-mother-name">
                        <label for="regular2">{{ 'mothersName' | translate }}</label>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group  parentDetail">
                        <input type="text" [placeholder]="'enterContactNumber' | translate" id="add-student-mother-mobile-number-new"
                          [ngModelOptions]="{standalone: true}" class="form-control" [ngClass]="{
                            'add-student-contact-field': !invalidAddStudentMotherMobileNumber,
                            'add-student-contact-field-error': invalidAddStudentMotherMobileNumber
                          }" #addStudentMotherMobileNumber
                          (input)="handleDebounceAddStudentMotherMobileNumber(addStudentMotherMobileNumber)"
                          (keydown)="handleKeyDown($event)" autocomplete="off"
                          [(ngModel)]="addNewStudentMotherNumberInput" maxlength="20" />
                        <label for="regular2">{{ 'contactNumber' | translate }}</label>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <select [(ngModel)]="addNewStudentMotherOccupation" [ngModelOptions]="{standalone: true}"
                          id="admission-mother-occupation" name="select1" class="form-control"
                          style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                          <option value="0"></option>
                          <option value="Agriculture, Food and Natural Resources">{{ 'agricultureFoodAndNaturalResources' | translate }}</option>
                          <option value="Architecture and Construction">{{ 'architectureAndConstruction' | translate }}</option>
                          <option value="Arts, Audio/Video Technology and Communications">{{ 'artsAudio/videoTechnologyAndCommunications' | translate }}</option>
                          <option value="Business Management and Administration">{{ 'businessManagementAndAdministration' | translate }}
                          </option>
                          <option value="Education and Training">{{ 'educationAndTraining' | translate }}</option>
                          <option value="Finance">{{ 'finance' | translate }}</option>
                          <option value="Government and Public Administration">{{ 'governmentAndPublicAdministration' | translate }}
                          </option>
                          <option value="Health Science">{{ 'healthScience' | translate }}</option>
                          <option value="Hospitality and Tourism">{{ 'hospitalityAndTourism' | translate }}</option>
                          <option value="Human Services">{{ 'humanServices' | translate }}</option>
                          <option value="Information Technology">{{ 'informationTechnology' | translate }}</option>
                          <option value="Law, Public Safety, Corrections and Security">{{ 'lawPublicSafetyCorrectionsAndSecurity' | translate }}</option>
                          <option value="Manufacturing">{{ 'manufacturing' | translate }}</option>
                          <option value="Marketing, Sales and Service">{{ 'marketingSalesAndService' | translate }}</option>
                          <option value="Science, Technology, Engineering and Mathematics">{{ 'scienceTechnologyEngineeringAndMathematics' | translate }}</option>
                          <option value="Transportation, Distribution and Logistics">{{ 'transportationDistributionAndLogistics' | translate }}</option>
                          <option value="Others">{{ 'others' | translate }}</option>
                        </select>
                        <label for="admission-mother-occupation">{{ 'occupation' | translate }}</label>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <input (change)="addNewStudentMotherQualificationOnchange()"
                          [(ngModel)]="addNewStudentMotherQualification" [ngModelOptions]="{standalone: true}"
                          type="text" class="form-control changeMotherQuali" id="motherquali">
                        <label for="regular2">{{ 'educationalQualification' | translate }}</label>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <input type="text" class="form-control" id="mother-annual-income"
                          [ngModelOptions]="{standalone: true}" [(ngModel)]="addNewStudentMotherAnnualIncome"
                          (keydown)="handleKeyDown($event)">
                        <label for="regular2">{{ 'annualIncome' | translate }}</label>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="form-group">
                        <input [(ngModel)]="addNewMotherPinCode" [ngModelOptions]="{standalone: true}"
                          class="form-control" id="mother-pincode" maxlength="6" type="text"
                          (keydown)="handleKeyDown($event)">
                        <label for="mother-pincode">{{ 'pinCode' | translate }} </label>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <input (change)="addMotherEmailOnchange()" type="text" [(ngModel)]="addNewMotherEmail"
                          [ngModelOptions]="{standalone: true}" class="form-control changeMotherEmail" id="admission-mother-email">
                        <label for="admission-mother-email">{{ 'motherEmail' | translate }}</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="form-group">
                        <div class="checkbox checkbox-styled">
                          <label>
                            <input (change)=getFatherAddress(addNewStudentMotherSameFatherAddress)
                              [(ngModel)]="addNewStudentMotherSameFatherAddress" [ngModelOptions]="{standalone: true}"
                              type="checkbox" value="">
                            <span>{{ 'useFathersAddress,pinCodeAndMobileNumber' | translate }}</span>
                          </label>
                        </div>
                      </div>
                      <div class="form-group">
                        <textarea [(ngModel)]="addNewStudentMotherAddress" [ngModelOptions]="{standalone: true}"
                          name="textarea1" id="admission-mother-address" class="form-control changeMotherAdd" rows="3"
                          style="text-transform: initial;border: 1px solid #e8e8e8;padding: 12px 10px;margin-top: 5px;"></textarea>
                        <label for="staddress">{{ 'contactAddress' | translate }}</label>
                      </div>
                    </div>
                  </div>
                  <div class="row" style="margin: 0;">
                    <div class="col-md-12">
                      <h5 style="margin-top: 0;">{{ 'guardiansInfo' | translate }}</h5>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group ">
                        <input (change)="addNewStudentGuardianNameOnchange()" [(ngModel)]="addNewStudentGuardianName"
                          [ngModelOptions]="{standalone: true}" type="text" class="form-control changeGuardianName"
                          id="guardianname">
                        <label for="regular2">{{ 'guardiansName' | translate }}</label>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group parentDetail">
                        <input type="text" [placeholder]="'enterContactNumber' | translate" id="add-student-guardian-mobile-number-new"
                          [ngModelOptions]="{standalone: true}" class="form-control" [ngClass]="{
                            'add-student-contact-field': !invalidAddStudentGuardianMobileNumber,
                            'add-student-contact-field-error': invalidAddStudentGuardianMobileNumber
                          }" #addStudentGuardianMobileNumber
                          (input)="handleDebounceAddStudentGuardianMobileNumber(addStudentGuardianMobileNumber)"
                          (keydown)="handleKeyDown($event)" autocomplete="off"
                          [(ngModel)]="addNewStudentGuardianNumberInput" maxlength="20" />

                        <label for="regular2">{{ 'contactNumber' | translate }}</label>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <select [(ngModel)]="addNewStudentGuardianOccupation" [ngModelOptions]="{standalone: true}"
                          id="admission-guardian-occupation" name="select1" class="form-control"
                          style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                          <option value="0"></option>
                          <option value="Agriculture, Food and Natural Resources">{{ 'agricultureFoodAndNaturalResources' | translate }}
                            {{ 'resources' | translate }}</option>
                          <option value="Architecture and Construction">{{ 'architectureAndConstruction' | translate }}</option>
                          <option value="Arts, Audio/Video Technology and Communications">{{ 'artsAudio/videoTechnologyAndCommunications' | translate }}</option>
                          <option value="Business Management and Administration">{{ 'businessManagementAndAdministration' | translate }}
                          </option>
                          <option value="Education and Training">{{ 'educationAndTraining' | translate }}</option>
                          <option value="Finance">{{ 'finance' | translate }}</option>
                          <option value="Government and Public Administration">{{ 'governmentAndPublicAdministration' | translate }}
                          </option>
                          <option value="Health Science">{{ 'healthScience' | translate }}</option>
                          <option value="Hospitality and Tourism">{{ 'hospitalityAndTourism' | translate }}</option>
                          <option value="Human Services">{{ 'humanServices' | translate }}</option>
                          <option value="Information Technology">{{ 'informationTechnology' | translate }}</option>
                          <option value="Law, Public Safety, Corrections and Security">{{ 'lawPublicSafetyCorrectionsAndSecurity' | translate }}</option>
                          <option value="Manufacturing">{{ 'manufacturing' | translate }}</option>
                          <option value="Marketing, Sales and Service">{{ 'marketingSalesAndService' | translate }}</option>
                          <option value="Science, Technology, Engineering and Mathematics">{{ 'scienceTechnologyEngineeringAndMathematics' | translate }}</option>
                          <option value="Transportation, Distribution and Logistics">{{ 'transportationDistributionAndLogistics' | translate }}</option>
                          <option value="Others">{{ 'others' | translate }}</option>
                        </select>
                        <label for="admission-guardian-occupation">{{ 'occupation' | translate }}</label>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <input (change)="addNewStudentGuardianQualificationOnchange()"
                          [(ngModel)]="addNewStudentGuardianQualification" [ngModelOptions]="{standalone: true}"
                          type="text" class="form-control changeGuardianQuali" id="guardianqual">
                        <label for="regular2">{{ 'educationalQualification' | translate }}</label>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <input type="text" class="form-control" id="guardian-annual-income"
                          [ngModelOptions]="{standalone: true}" [(ngModel)]="addNewStudentGuardianAnnualIncome"
                          (keydown)="handleKeyDown($event)">
                        <label for="regular2">{{ 'annualIncome' | translate }}</label>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="form-group">
                        <input [(ngModel)]="addNewGuardianPinCode" [ngModelOptions]="{standalone: true}"
                          class="form-control" id="guardian-pincode" maxlength="6" type="text"
                          (keydown)="handleKeyDown($event)">
                        <label for="guardian-pincode">{{ 'pinCode' | translate }} </label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="checkbox checkbox-styled">
                        <label>
                          <input (change)=getFatherAddressForGuadian(addNewStudentGuardianSameFatherAddress)
                            [(ngModel)]="addNewStudentGuardianSameFatherAddress" [ngModelOptions]="{standalone: true}"
                            type="checkbox" value="">
                          <span>{{ 'useFathersAddressAndPinCode' | translate }}</span>
                        </label>
                      </div>
                      <div class="form-group">
                        <textarea [(ngModel)]="addNewStudentGuardianAddress" [ngModelOptions]="{standalone: true}"
                          name="textarea1" id="guardianaddress" class="form-control changeGuardianAdd" rows="3"
                          style="text-transform: initial;border: 1px solid #e8e8e8;padding: 12px 10px;margin-top: 5px;"></textarea>
                        <label for="staddress">{{ 'contactAddress' | translate }}</label>
                      </div>
                    </div>

                  </div>
                </div>
                <!-- bus info -->
                <div class="row" style="margin: 0;min-height: 300px;">
                  <div class="col-md-12">
                    <h4 style="background: #f7f7f7;padding: 10px 10px;margin-top: 0;">{{ 'selectTransportOptions' | translate }}</h4>

                    <div class="col-md-6">
                      <div class="form-group">
                        <select id="bus-stop-selection-add_"
                          (change)="addStd_updateSelectedBusRoute($event.target.value)" name="bus-stop-selection-add_"
                          class="form-control routeforbus"
                          style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                          <option [value]="0">{{ 'notAssigned' | translate }}</option>
                          <option *ngFor="let o of busStopListData" [value]="o.PkBusStopId">{{o.BusStopName}}</option>
                        </select>
                        <label for="bus-stop-selection-add_">{{ 'selectStop' | translate }}</label>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <select id="bus-selection-add_" (change)="addStudentBusSelect($event.target.value)"
                          name="bus-selection-add_" class="form-control"
                          style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                          <option [value]="0">{{ 'notAssigned' | translate }}</option>
                          <option *ngFor="let o of busListData" [value]="o.pkBusId">
                            {{o.BusName}}-{{o.BusNumber}}-{{o.RouteName}}({{o.startStop}} to
                            {{o.endStop}})-(Capacity-{{o.Capacity}})-(Filled-{{o.assignedStudents}})</option>
                        </select>
                        <label for="bus-selection-add_">{{ 'selectBus' | translate }}</label>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-group">
                        <input [(ngModel)]="mTotalBusFees" [ngModelOptions]="{standalone: true}" type="text"
                          class="form-control" id="regular1"
                          style="padding: 35px 10px;font-size: 20px;border: 1px dashed #e2e2e2;color: darkslategray;"
                          disabled="disabled">
                        <label for="regular1">{{ 'fare' | translate }}({{schoolCurrency}})</label>
                      </div>

                    </div>
                    <div *ngIf="isTermsVisible" id="select_busterm_layout" class="col-md-12 animated fadeInUp">
                      <h5>{{ 'selectTerms' | translate }}:</h5>
                      <label class="checkbox-inline checkbox-styled">
                        <input type="checkbox" (change)="onBusTermChangedSelectAllTerms($event)"><span>{{ 'selectAllTerms' | translate }}
                        </span>
                      </label>
                      <div>
                        <label *ngFor="let term of avalialableTermsList" class="checkbox-inline checkbox-styled">
                          <input type="checkbox" [checked]="term.isSelectedTerm" value="{{term.pkBusStopTermId}}"
                            (change)="onBusTermChanged($event,term.pkBusStopTermId)"><span>{{term.termName}} ({{'dueDate' | translate}}:
                            {{term.termDueDate | date}})</span>
                        </label>
                      </div>

                    </div>

                  </div>
                </div>
                <!-- Finish /////////////////////-->
                <div class="row" style="background: white;margin: 15px 0px;margin-top: 25px;">
                  <div class="col-md-12">
                    <p class="pull-left text-lg"
                      style="position: relative;background: #888888;color: white;padding: 0px 10px;box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.33);margin-right: 10px;">
                      4</p>
                    <h4 style="padding: 10px 10px;margin-top: 0;font-weight: 400;color: #888888;">{{ 'finish' | translate }}</h4>
                  </div>
                  <div class="col-md-12 scrollbar-style" style="padding-top: 3em;">
                    <div class="col-md-8" style="text-align: center;padding: 80px 0px;border: 1px dashed #e8e8e8;">
                      <p class="lead" style="font-size: 25px;color: #868585;margin: 0;">{{ 'hereYouGoWithNewStudent' | translate }}
                      </p>
                      <h4 style="color: #6b6b6b;font-weight: 300;">{{ 'uploadTheStudentPhotoAndClickFinishToCompleteTheAdmission' | translate }}</h4>
                    </div>
                    <div class="col-md-4">
                      <div class="cropme-admission student-image"
                        style="width: 150px;min-height: 150px;float: initial;margin: 0 auto;border: 1px dashed  #e0e0e0;">
                        <img [src]="addNewStudentImage" id="studentimage" class="img-responsive"
                          style="margin: 0 auto;width: 75px;">
                      </div>
                      <div class="col-md-12" style="text-align:center;">
                        <div class="col-md-12" style="text-align:center;">
                          <h5 class="progress hide" id="student-progressbar"
                            style="text-align: center;cursor: pointer;display: inline-block;border: 1px solid #e2e2e2;padding: 9px 0px;margin: 1em -2em;color: var(--secondary-btn-bg-color);font-size: 9px;text-transform: uppercase;width: 150px;">
                            {{ 'uploading' | translate }}</h5>
                        </div>
                        <input type="file" class="input-style" id="openbrowser" style="width:1px; height: 1px">
                        <h5 (click)="openbrowsertouplaodphoto()" class="image-edit hide" id="hidetxtbox"
                          style="text-align: center;cursor: pointer;display: inline-block;border: 1px solid #e2e2e2;padding: 5px 0px;margin: 1em;color: var(--secondary-btn-bg-color);font-size: 9px;text-transform: uppercase;width: 150px;">
                          {{ 'uploadStudentImage' | translate }}</h5>
                      </div>
                      <div class="col-md-12" style="text-align: center;">
                        <button (click)="addNewStudentFinish()" id="addStudentbutton" type="button"
                          class="btn btn-raised ink-reaction btn-info" data-toggle="dropdown" aria-expanded="false"
                          style="padding: 5px 75px;margin-bottom: -1em;">
                          {{ 'finish' | translate }}
                        </button>
                        <div id="new-student-progress-div" class="progress hide"
                          style="width: 300px;border-radius: 40px;    margin-top: 20px;">
                          <span id="new-student-percent-text"
                            style="position: absolute;margin-left: -50%;color: #2b323a;width: 100%"></span>
                          <div id="new-student-percent-progress"
                            class="progress-bar progress-bar-success progress-bar-striped active" role="progressbar"
                            aria-valuenow="40" aria-valuemin="0" aria-valuemax="100">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <!-- End Student details -->
          <!-- End Student details -->
        </div>
      </div>
      <!--/////-->

      <!--View student offcanvas -->
      <div id="offcanvas-view-student" class="offcanvas-pane width-12" style="width:1000px;    overflow-x: hidden;">
        <div class="offcanvas-head" style="    padding: 0;">
          <!-- Student details -->
          <div id="particles-view-student" class="row" style="background: var(--secondary-btn-bg-color);min-height: 250px;">
            <div class="particles-content">
              <div class="col-md-12" style="position: fixed;z-index: 999;top: 0em;">
                <h3 class="pull-right" style="color: white;cursor: pointer;" data-dismiss="offcanvas"><i
                    class="fa fa-close"></i></h3>
              </div>
              <div class="col-md-12 text-center">
                <p class="lead text-center"
                  style="color: #ffffff;text-transform: uppercase; letter-spacing: 1px;margin-bottom: 10px;">{{ 'studentDetails' | translate }}</p>
                <img src="assets/img/student-avatar.png" class="img-responsive" style="margin: 0 auto;width: 75px;">
                <p style="margin: 15px 0px; color: white; font-weight: 100;">{{ 'view' | translate }} <b>/</b> {{ 'manageTheStudentDetailsHere' | translate }}</p>
              </div>
            </div>
          </div>
          <div class="row" style="background: #f1f1f1;">
            <div class="col-md-12">
              <h4 class="lead pull-left"
                style="margin: 10px 10px;color: #888888;letter-spacing: 1px;font-size: 12px;text-transform: uppercase;">
                {{ 'selectedStudentDetails' | translate }}</h4>
              <div style="position: absolute;float: inherit;width: inherit;right: 2em;top: -12px;">
                <button *ngIf="permissions.EDIT_STUDENT == 'ENABLED'" type="button"
                  (click)="callClass();selectcategoryFunctionAdd(selectedStudentclasscategoryId);selectclassFunctionAdd(selectedStudentclassnameId)"
                  class="pull-right btn ink-reaction btn-floating-action btn-primary"
                  style="background: #E91E63;border: none;width: 60px;height: 60px;"><i
                    class="fa fa-pencil-square-o"></i></button>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12" style="padding: 15px 25px;">
              <form class="form student-detail-summary">
                <div class="row" style="margin: 0;">
                  <div class="col-md-3" style="margin-top: 1em;text-align: center;">
                    <div class=""
                      style="width: 150px;min-height: 150px;float: initial;margin: 0 auto;border: 1px dashed  #e0e0e0;text-align: center;">
                      <img class="img-responsive" src="{{selectedStudentimage}}"
                        style="margin: 0 auto;max-width: 150px;max-height: 150px;">
                    </div>
                  </div>
                  <div class="col-md-9">
                    <h5>{{ 'basicInfo' | translate }}:</h5>
                  </div>
                  <div class="col-md-5">
                    <div class="form-group">
                      <input disabled type="text" class="form-control" value="{{selectedStudentname}}">
                      <label for="stname">{{ 'name' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <input disabled type="text" class="form-control" value="{{selectedStudentsurname}}">
                      <label for="stname">{{ 'surname' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="form-group">
                      <input disabled type="text" class="form-control" value="{{selectedStudentemail}}">
                      <label for="stname">{{ 'studentEmail' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group">
                      <select id="addNewStudent-view-countryCode" name="countrycodenewstu"
                        value="{{selectedStudentMobileCountryCode}}" class="form-control"
                        style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                        <option *ngFor="let code of countryCode" [value]="code.code"
                          [attr.data-countryCode]="code.country_code">
                          {{ code.name }} ({{ code.dial_code }})
                        </option>
                      </select>
                      <label for="addNewStudent-view-countryCode">{{ 'countryCode' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group">
                      <input disabled type="text" class="form-control" value="{{selectedStudentcontact}}" type="number"
                        maxlength="10">
                      <label for="stname">{{ 'studentContact' | translate }}</label>
                    </div>
                  </div>
                </div>
                <div class="row" style="margin: 0;">
                  <div class="col-md-3">
                    <div class="form-group">
                      <input disabled type="text" class="form-control"
                        value="{{selectedStudentadmissiondate | date: 'MMM dd, yyyy '}}">
                      <label for="admdate">{{ 'admisssionDate' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <input disabled type="text" class="form-control" value="{{selectedStudentadmissionnumber}}">
                      <label for="admnum">{{ 'admissionNumber' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <input disabled type="text" class="form-control"
                        value="{{selectedStudentdateofbirth | date: 'MMM dd, yyyy '}}">
                      <label for="dob">{{ 'dateOfBirth' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label>{{ 'gender' | translate }}</label>
                      <div class="btn-group" data-toggle="buttons" style="margin-top: 12px;width: 100%;">
                        <label class="btn ink-reaction btn-primary" style="font-size: 10px;width: 50%;"
                          [attr.disabled]="true" [class.active]="selectedStudentgender">
                          <input type="radio" name="options"><i class="fa fa-male fa-fw"></i> {{ 'male' | translate }}
                        </label>
                        <label class="btn ink-reaction btn-primary" style="font-size: 10px;width: 50%;"
                          [attr.disabled]="true" [class.active]="!selectedStudentgender">
                          <input type="radio" name="options"><i class="fa fa-female fa-fw"></i> {{ 'female' | translate }}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" style="margin: 0;">
                  <div class="col-md-3">
                    <div class="form-group">
                      <input disabled type="text" class="form-control" value="{{selectedStudentclasscategory}}">
                      <label for="add-clname">{{ 'category' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <input disabled type="text" class="form-control" value="{{selectedStudentclassname}}">
                      <label for="add-clname">{{ 'class' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <input disabled type="text" class="form-control" value="{{selectedStudentclasssection}}">
                      <label for="add-clname">{{ 'section' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <input disabled type="text" class="form-control" value="{{selectedStudentclassid}}">
                      <label for="classid">{{ 'classId' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <input disabled type="text" class="form-control"
                        value="{{selectedStudentCategory || 'General/ Default'}}">
                      <label for="classid">{{ 'studentCategory' | translate }}</label>
                    </div>
                  </div>
                </div>
                <div class="row" style="margin: 0;">
                  <div class="col-md-6">
                    <h5>{{ 'bluewingsAppStatus' | translate }}:</h5>
                    <div class="col-md-12" style="padding: 10px;border: 1px solid #e8e8e8;">
                      <label class="radio-inline radio-styled">
                        <input type="radio" name="edit-connected"
                          [attr.checked]="selectedStudentbwappstatus ? true : null"
                          [attr.disabled]="!selectedStudentbwappstatus ? true : null"><span>{{ 'connected' | translate }}</span>
                      </label>
                      <label class="radio-inline radio-styled">
                        <input type="radio" name="edit-connected"
                          [attr.checked]="!selectedStudentbwappstatus ? true : null"
                          [attr.disabled]="selectedStudentbwappstatus ? true : null"><span>{{ 'disconnected' | translate }}</span>
                      </label>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <h5>{{ 'accountStatus' | translate }}:</h5>
                    <div class="col-md-12" style="padding: 10px;border: 1px solid #e8e8e8;">
                      <label class="radio-inline radio-styled">
                        <input type="radio" name="edit-acc-stat"
                          [attr.checked]="selectedStudentaccountstatus ? true : null"
                          [attr.disabled]="!selectedStudentaccountstatus ? true : null"><span>{{ 'active' | translate }}</span>
                      </label>
                      <label class="radio-inline radio-styled">
                        <input type="radio" name="edit-acc-stat"
                          [attr.checked]="!selectedStudentaccountstatus ? true : null"
                          [attr.disabled]="selectedStudentaccountstatus ? true : null"><span>{{ 'deactive' | translate }}</span>
                      </label>
                    </div>
                  </div>
                </div>
                <!-- father info -->
                <div class="row" style="margin: 0;margin-top: 15px;">
                  <div class="col-md-12">
                    <h5>{{ 'fathersInfo' | translate }}:</h5>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <input disabled type="text" class="form-control" value="{{selectedStudentfathername}}">
                      <label for="regular2">{{ 'fathersName' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group">
                      <select id="addNewStudent-view-countryCode-father" name="countrycodenewstufather"
                        value="{{selectedStudentMobileCountryCode}}" class="form-control"
                        style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                        <option *ngFor="let code of countryCode" [value]="code.code"
                          [attr.data-countryCode]="code.country_code">
                          {{ code.name }} ({{ code.dial_code }})
                        </option>
                      </select>
                      <label for="addNewStudent-view-countryCode-father">{{ 'countryCode' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group">
                      <input disabled type="text" class="form-control" value="{{selectedStudentfathercontact}}">
                      <label for="regular2">{{ 'contactNumber' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group">
                      <input disabled type="text" class="form-control" value="{{selectedStudentfatheroccupation}}">
                      <label for="regular2">{{ 'occupation' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <input disabled type="text" class="form-control" value="{{selectedStudentfatherqualification}}">
                      <label for="regular2">{{ 'educationalQualification' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <textarea disabled name="textarea1" class="form-control" rows="3"
                        style="text-transform: initial;padding: 12px 10px;margin-top: 5px;">{{selectedStudentfatheraddress}}</textarea>
                      <label for="staddress">{{ 'contactAddress' | translate }}</label>
                    </div>
                  </div>
                </div>
                <!-- mother info -->
                <div class="row" style="margin: 0;">
                  <div class="col-md-12">
                    <h5>{{ 'mothersInfo' | translate }}:</h5>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <input disabled type="text" class="form-control" value="{{selectedStudentmothername}}">
                      <label for="regular2">{{ 'mothersName' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group">
                      <select id="addNewStudent-view-countryCode-mother" name="countrycodenewstumother"
                        value="{{selectedStudentMobileCountryCode}}" class="form-control"
                        style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                        <option *ngFor="let code of countryCode" [value]="code.code"
                          [attr.data-countryCode]="code.country_code">
                          {{ code.name }} ({{ code.dial_code }})
                        </option>
                      </select>
                      <label for="addNewStudent-view-countryCode-mother">{{ 'countryCode' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group parentDetail">
                      <input disabled type="text" class="form-control" value="{{selectedStudentmothercontact}}">
                      <label for="regular2">{{ 'contactNumber' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group">
                      <input disabled type="text" class="form-control" value="{{selectedStudentmotheroccupation}}">
                      <label for="regular2">{{ 'occupation' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <input disabled type="text" class="form-control" value="{{selectedStudentmotherqualification}}">
                      <label for="regular2">{{ 'educationalQualification' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <textarea disabled name="textarea1" class="form-control" rows="3"
                        style="text-transform: initial;padding: 12px 10px;margin-top: 5px;">{{selectedStudentmotheraddress}}</textarea>
                      <label for="staddress">{{ 'contactAddress' | translate }}</label>
                    </div>
                  </div>
                </div>
                <!-- Guardian info -->
                <div class="row" style="margin: 0;">
                  <div class="col-md-12">
                    <h5>{{ 'guardiansInfo' | translate }}:</h5>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <input disabled type="text" class="form-control" value="{{selectedStudentguardianname}}">
                      <label for="regular2">{{ 'guardiansName' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group">
                      <select id="addNewStudent-view-countryCode-mother" name="countrycodenewstumother"
                        value="{{selectedStudentMobileCountryCode}}" class="form-control"
                        style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                        <option *ngFor="let code of countryCode" [value]="code.code"
                          [attr.data-countryCode]="code.country_code">
                          {{ code.name }} ({{ code.dial_code }})
                        </option>
                      </select>
                      <label for="addNewStudent-view-countryCode-mother">{{ 'countryCode' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group">
                      <input disabled type="text" class="form-control" value="{{selectedStudentguardiancontact}}">
                      <label for="regular2">{{ 'contactNumber' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group">
                      <input disabled type="text" class="form-control" value="{{selectedStudentguardianoccupation}}">
                      <label for="regular2">{{ 'occupation' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <input disabled type="text" class="form-control" value="{{selectedStudentguardianqualification}}">
                      <label for="regular2">{{ 'educationalQualification' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <textarea disabled name="textarea1" class="form-control" rows="3"
                        style="text-transform: initial;padding: 12px 10px;margin-top: 5px;">{{selectedStudentguardianaddress}}</textarea>
                      <label for="staddress">{{ 'contactAddress' | translate }}</label>
                    </div>
                  </div>
                </div>
                <!-- bus info -->
                <div class="row" style="margin: 0;min-height: 300px;">
                  <div class="col-md-12">
                    <h4 style="background: #f7f7f7;padding: 10px 10px;margin-top: 0;">{{ 'selectTransportOptions' | translate }}</h4>

                    <div class="col-md-6">
                      <div class="form-group">
                        <select disabled id="bus-stop-selection-view" name="select1" class="form-control"
                          style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                          <option [value]="0">{{ 'notAssigned' | translate }}</option>
                          <option *ngFor="let o of busStopListData" [value]="o.PkBusStopId">{{o.BusStopName}}</option>
                        </select>
                        <label for="add-clname">{{ 'route' | translate }}</label>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <select disabled id="bus-selection-view" name="select1" class="form-control"
                          style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                          <option [value]="0">{{ 'notAssigned' | translate }}</option>
                          <option *ngFor="let o of busListData" [value]="o.pkBusId">{{o.BusName}} - {{o.BusNumber}} -
                            {{o.RouteName}}</option>
                        </select>
                        <label for="add-clname">{{ 'stop' | translate }}</label>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-group">
                        <input [(ngModel)]="mTotalBusFees" [ngModelOptions]="{standalone: true}" type="text"
                          class="form-control" id="regular1"
                          style="padding: 35px 10px;font-size: 20px;border: 1px dashed #e2e2e2;color: darkslategray;"
                          disabled="disabled">
                        <label for="regular1">{{ 'fare' | translate }}({{schoolCurrency}})</label>
                      </div>

                    </div>

                    <div id="view_busterm_layout" class="col-md-12 animated fadeInUp">
                      <h5>{{ 'selectTerms' | translate }}:</h5>
                      <label *ngFor="let term of viewStudentTerms" class="checkbox-inline checkbox-styled">
                        <input disabled type="checkbox" checked value="{{term.pkBusStopTermId}}"><span>{{term.termName}}
                          ({{'dueDate' | translate}}: {{term.termDueDate | date}})</span>
                      </label>

                    </div>

                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <!-- End view student off canvas -->


      <!--Edit student offcanvas -->
      <div id="offcanvas-edit-student" class="offcanvas-pane width-12" style="width:1000px;    overflow-x: hidden;">
        <div class="offcanvas-head" style="    padding: 0;">
          <!-- Student details -->
          <div id="particles-edit-student" class="row" style="background: var(--secondary-btn-bg-color);min-height: 250px;">
            <div class="particles-content">
              <div class="col-md-12" style="position: fixed;z-index: 999;top: 0em;">
                <h3 id="closeUpdateSt" class="pull-right" style="color: white;cursor: pointer;"
                  data-dismiss="offcanvas"><i class="fa fa-close"></i></h3>
              </div>
              <div class="col-md-12 text-center">
                <p class="lead text-center"
                  style="color: #ffffff;text-transform: uppercase; letter-spacing: 1px;margin-bottom: 10px;">{{ 'editStudent' | translate }}</p>
                <img src="assets/img/student-avatar.png" class="img-responsive" style="margin: 0 auto;width: 75px;">
                <p style="margin: 15px 0px; color: white; font-weight: 100;">{{ 'editDetailsOfTheSelectedStudent' | translate }}</p>
              </div>
            </div>
          </div>
          <div class="row" style="background: #f1f1f1;">
            <div class="col-md-12">
              <h4 class="lead pull-left"
                style="margin: 10px 10px;color: #888888;letter-spacing: 1px;font-size: 12px;text-transform: uppercase;">
                {{ 'editSelectedStudentDetails' | translate }}</h4>
              <div style="position: absolute;float: inherit;width: inherit;right: 2em;top: -12px;">
                <button type="button" class="pull-right btn ink-reaction btn-floating-action btn-primary"
                  (click)="offcanvasViewStudent();"
                  style="background: #E91E63;border: none;width: 60px;height: 60px;"><i
                    class="fa fa-chevron-left"></i></button>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12" style="padding: 15px 25px;">
              <div class="" [class.hidden]="!loaderEditStudent"
                style="position: absolute;width: 100%;height: 100%;left: 0;background: #ffffff;z-index: 999;">
                <div class="col-md-12" style="text-align: center;position: fixed;margin-top: 75%;">
                  <img src="assets/img/search_icon_animation.gif" style="   width: 300px;">
                  <h3 style="margin: 0;margin-top: -2em;color: #a1a1a1;font-weight: 400;">{{ 'pleaseWait' | translate }}</h3>
                </div>
              </div>
              <form class="form student-detail-summary">
                <div class="row" style="margin: 0;">
                  <div class="col-md-3" style="margin-top: 1em;text-align: center;">
                    <div class="cropme-student-edit student-image"
                      style="width: 150px;min-height: 150px;float: initial;margin: 0 auto;border: 1px dashed  #e0e0e0;text-align: center;">
                      <img class="img-responsive" src="{{selectedStudentimage}}" id="editstudentimage"
                        style="margin: 0 auto;max-width: 150px;max-height: 150px;">
                    </div>
                    <div class="col-md-12" style="text-align:center;">
                      <div class="col-md-12" style="text-align:center;">
                        <h5 class="progress hide" id="editStudent-progressbar"
                          style="text-align: center;cursor: pointer;display: inline-block;border: 1px solid #e2e2e2;padding: 9px 0px;margin: 1em -2em;color: var(--secondary-btn-bg-color);font-size: 9px;text-transform: uppercase;width: 150px;">
                          {{ 'uploading' | translate }}</h5>
                      </div>
                      <input type="file" class="input-style" id="openbrowserforeditstudent"
                        style="width:1px; height: 1px">
                      <h5 (click)="openbrowsertouplaodphotoeditstudent()" id="hidetextboxedit" class="image-edit hide"
                        style="text-align: center;cursor: pointer;display: inline-block;border: 1px solid #e2e2e2;padding: 5px 0px;margin: 1em;color: var(--secondary-btn-bg-color);font-size: 9px;text-transform: uppercase;width: 150px;">
                        {{ 'updateStudentImage' | translate }}</h5>
                    </div>
                  </div>
                  <div class="col-md-9">
                    <h5>{{ 'basicInfo' | translate }}:</h5>
                  </div>
                  <div class="col-md-5">
                    <div class="form-group">
                      <input (change)="editStudentNameOnchange(editstudentName.value)" id="edit-studentname" type="text"
                        class="form-control" value="{{selectedStudentname}}" #editstudentName>
                      <label for="stname">{{ 'name' | translate }}<span style="color: #F44336;">*</span></label>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <input (change)="editStudentSurNameOnchange(editstudentSurname.value)" id="edit-student-surname"
                        type="text" class="form-control" value="{{selectedStudentsurname}}" #editstudentSurname>
                      <label for="stname">{{ 'surname' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="form-group">
                      <input (change)="editStudentEmailOnchange(editstudentStudentEmail.value)" id="edit-student-email"
                        type="text" class="form-control" value="{{selectedStudentemail}}" #editstudentStudentEmail>
                      <label for="stname">{{ 'studentEmail' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group">
                      <select id="addNewStudent-edit-countryCode" name="countrycodenewstuedit"
                        value="{{selectedStudentMobileCountryCode}}" #editstudentStudentMobCountryCode
                        class="form-control"
                        style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                        >
                        <option *ngFor="let code of countryCode" [value]="code.code"
                          [attr.data-countryCode]="code.country_code">
                          {{ code.name }} ({{ code.dial_code }})
                        </option>
                      </select>
                      <label for="addNewStudent-edit-countryCode">{{ 'countryCode' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group">
                      <input (change)="editStudentContactOnchange(editstudentStudentContactnNumber.value)"
                        id="edit-student-num" type="text" class="form-control" value="{{selectedStudentcontact}}"
                        #editstudentStudentContactnNumber>
                      <label for="stname">{{ 'studentContact' | translate }}</label>
                    </div>
                  </div>
                </div>
                <div class="row" style="margin: 0;">
                  <div class="col-md-3">
                    <div class="form-group">
                      <input id="edit-student-admissiondate" disabled type="text" class="form-control"
                        value="{{selectedStudentadmissiondate | date: 'MMM dd, yyyy '}}" data-provide="datepicker"
                        data-date-format="dd/mm/yyyy" data-date-end-date="0d">
                      <label for="admdate">{{ 'admisssionDate' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <input (change)="editStudentAdmissionNumOnchange()" id="edit-student-admissionnum" type="text"
                        class="form-control" value="{{selectedStudentadmissionnumber}}">
                      <label for="admnum">{{ 'admissionNumber' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <input type="text" id="editstudentdob" class="form-control"
                        value="{{selectedStudentdateofbirth | date: 'dd/MM/y'}}" data-provide="datepicker"
                        data-date-format="dd/mm/yyyy" data-date-end-date="0d" #editstudentStudentDOB>
                      <label for="dob">{{ 'dateOfBirthDd/mm/yyyy' | translate }}<span style="color: #F44336;">*</span></label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label>{{ 'gender' | translate }}</label>
                      <div class="btn-group" data-toggle="buttons" style="margin-top: 12px;width: 100%;">
                        <label class="btn ink-reaction btn-primary statusGenderMale" style="font-size: 10px;width: 50%;"
                          [class.active]="selectedStudentgender">
                          <input type="radio" name="options" #editstudentStudentGenderMale><i
                            class="fa fa-male fa-fw"></i> {{ 'male' | translate }}
                        </label>
                        <label class="btn ink-reaction btn-primary statusGenderFemale"
                          style="font-size: 10px;width: 50%;" [class.active]="!selectedStudentgender">
                          <input type="radio" name="options" #editstudentStudentGenderFemale><i
                            class="fa fa-female fa-fw"></i> {{ 'female' | translate }}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" style="margin: 0;">
                  <!--Class Section-->
                  <div class="col-md-3">
                    <div class="form-group">
                      <select name="select13" class="form-control"
                        style="text-transform: uppercase;border: 1px solid #e2e2e2;"
                        (change)="selectcategoryFunctionAdd($event.target.value)" [(ngModel)]="classCatId"
                        id="edit-student-catId">
                        <option *ngFor="let category of schoolCategories" value="{{category.categoryId}}">
                          {{category.categoryName}}</option>
                      </select>
                      <label for="add-clname">{{ 'category' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <select name="select13" class="form-control"
                        style="text-transform: uppercase;border: 1px solid #e2e2e2;"
                        (change)="selectclassFunctionAdd($event.target.value)" [(ngModel)]="selectedStudentclassnameId"
                        [ngModelOptions]="{standalone: true}" id="edit-student-classId">
                        <option *ngFor="let class of schoolClassesAdd" value="{{class.classid}}">{{class.classname}}
                        </option>
                      </select>
                      <label for="add-clname">{{ 'class' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <select [(ngModel)]="sectionIdChange" [ngModelOptions]="{standalone: true}"
                        id="edit-student-section" name="select13" class="form-control"
                        style="text-transform: uppercase;border: 1px solid #e2e2e2;">
                        <option *ngFor="let section of schoolClassesSectionsAdd" value="{{section.claaSectionId}}">
                          {{section.classSection}}</option>
                      </select>
                      <label for="add-clname">{{ 'section' | translate }}</label>
                    </div>
                  </div>
                  <!--End Class Section-->
                  <div class="col-md-3">
                    <div class="form-group">
                      <input (change)="editStudentChangeclassRoll(editstudentStudentClassId.value)"
                        id="edit-student-roll" type="text" class="form-control" value="{{selectedStudentclassid}}"
                        #editstudentStudentClassId>
                      <label for="classid">{{ 'classIdRollNumber' | translate }}</label>
                    </div>
                  </div>
                </div>
                <div class="row" style="margin: 0;">
                  <div class="col-md-6">
                    <h5>{{ 'changeBluewingsAppStatus' | translate }}:</h5>
                    <div class="col-md-12" style="padding: 10px;border: 1px solid #e8e8e8;">
                      <label class="radio-inline radio-styled">
                        <input id="appStatusConected" #editstudentStudentAppStausConnected type="radio"
                          name="edit-connected"
                          [attr.checked]="selectedStudentbwappstatus ? true : null"><span>{{ 'connected' | translate }}</span>
                      </label>
                      <label class="radio-inline radio-styled">
                        <input id="appStatusDisConneted" #editstudentStudentAppStausDisConnected type="radio"
                          name="edit-connected"
                          [attr.checked]="!selectedStudentbwappstatus ? true : null"><span>{{ 'disconnected' | translate }}</span>
                      </label>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <h5>{{ 'changeAccountStatus' | translate }}:</h5>
                    <div class="col-md-12" style="padding: 10px;border: 1px solid #e8e8e8;">
                      <label class="radio-inline radio-styled">
                        <input id="accountStatusActive" #editstudentStudentAccountActive type="radio"
                          name="edit-acc-stat"
                          [attr.checked]="selectedStudentaccountstatus ? true : null"><span>{{ 'active' | translate }}</span>
                      </label>
                      <label class="radio-inline radio-styled">
                        <input id="accountStatusDeActive" #editstudentStudentAccountDeActive type="radio"
                          name="edit-acc-stat"
                          [attr.checked]="!selectedStudentaccountstatus ? true : null"><span>{{ 'deactive' | translate }}</span>
                      </label>
                    </div>
                  </div>
                  <div id="reason" class="col-md-6 col-md-offset-6" style="display: none">
                    <div class="form-group">
                      <input #reasonForDeactiveStudent type="text" class="form-control">
                      <label for="regular2">{{ 'reason' | translate }}<span style="color: #F44336;">*</span></label>
                    </div>
                  </div>
                </div>


                <!-- father info -->
                <div class="row" style="margin: 0;margin-top: 15px;">
                  <div class="col-md-12">
                    <h5>{{ 'fathersInfo' | translate }}:</h5>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <input (change)="editStudentChangeFatherName(editstudentFatherName.value)"
                        id="edit-student-fathername" value="{{selectedStudentfathername}}" #editstudentFatherName
                        type="text" class="form-control">
                      <label for="regular2">{{ 'fathersName' | translate }}<span style="color: #F44336;">*</span></label>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group">
                      <select id="addNewStudent-edit-countryCode-father" name="countrycodenewstueditfather"
                        value="{{selectedStudentMobileCountryCode}}" #editstudentStudentMobCountryCode
                        class="form-control"
                        style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                        <option *ngFor="let code of countryCode" [value]="code.code"
                          [attr.data-countryCode]="code.country_code">
                          {{ code.name }} ({{ code.dial_code }})
                        </option>
                      </select>
                      <label for="addNewStudent-edit-countryCode-father">{{ 'countryCode' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group">
                      <input (change)="editStudentChangeFatherNumber(editstudentFatherContact.value)"
                        id="edit-student-fathernum" #editstudentFatherContact type="text" class="form-control"
                        value="{{selectedStudentfathercontact}}" maxlength="10">
                      <label for="regular2">{{ 'contactNumber' | translate }}<span style="color: #F44336;">*</span></label>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group">
                      <select #editstudentFatherOccupation id="edit-student-father-occupation" name="select1"
                        class="form-control"
                        style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                        <option value="0"></option>
                        <option value="Agriculture, Food and Natural Resources">{{ 'agricultureFoodAndNaturalResources' | translate }}
                        </option>
                        <option value="Architecture and Construction">{{ 'architectureAndConstruction' | translate }}</option>
                        <option value="Arts, Audio/Video Technology and Communications">{{ 'artsAudio/videoTechnologyAndCommunications' | translate }}</option>
                        <option value="Business Management and Administration">{{ 'businessManagementAndAdministration' | translate }}
                        </option>
                        <option value="Education and Training">{{ 'educationAndTraining' | translate }}</option>
                        <option value="Finance">{{ 'finance' | translate }}</option>
                        <option value="Government and Public Administration">{{ 'governmentAndPublicAdministration' | translate }}
                        </option>
                        <option value="Health Science">{{ 'healthScience' | translate }}</option>
                        <option value="Hospitality and Tourism">{{ 'hospitalityAndTourism' | translate }}</option>
                        <option value="Human Services">{{ 'humanServices' | translate }}</option>
                        <option value="Information Technology">{{ 'informationTechnology' | translate }}</option>
                        <option value="Law, Public Safety, Corrections and Security">{{ 'lawPublicSafetyCorrectionsAndSecurity' | translate }}</option>
                        <option value="Manufacturing">{{ 'manufacturing' | translate }}</option>
                        <option value="Marketing, Sales and Service">{{ 'marketingSalesAndService' | translate }}</option>
                        <option value="Science, Technology, Engineering and Mathematics">{{ 'scienceTechnologyEngineeringAndMathematics' | translate }}</option>
                        <option value="Transportation, Distribution and Logistics">{{ 'transportationDistributionAndLogistics' | translate }}</option>
                        <option value="Others">{{ 'others' | translate }}</option>
                      </select>
                      <label for="regular2">{{ 'occupation' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <input (change)="editStudentChangeFatherQualification(editstudentFatherQualifiation.value)"
                        id="edit-student-fatherqual" #editstudentFatherQualifiation type="text" class="form-control"
                        value="{{selectedStudentfatherqualification}}">
                      <label for="regular2">{{ 'educationalQualification' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <textarea (change)="editStudentChangeFatherAdress(editstudentFatherAddress.value)"
                        id="edit-student-fatheraddress" #editstudentFatherAddress name="textarea1" class="form-control"
                        rows="3"
                        style="text-transform: initial;padding: 12px 10px;margin-top: 5px;">{{selectedStudentfatheraddress}}</textarea>
                      <label for="staddress">{{ 'contactAddress' | translate }}<span style="color: #F44336;">*</span></label>
                    </div>
                  </div>
                </div>
                <!-- mother info -->
                <div class="row" style="margin: 0;">
                  <div class="col-md-12">
                    <h5>{{ 'mothersInfo' | translate }}:</h5>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <input (change)="editStudentChangeMotherName(editstudentMotherName.value)"
                        id="edit-student-mothername" #editstudentMotherName type="text" class="form-control"
                        value="{{selectedStudentmothername}}">
                      <label for="regular2">{{ 'mothersName' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group">
                      <select id="addNewStudent-edit-countryCode-mother" name="countrycodenewstueditmother"
                        value="{{selectedStudentMobileCountryCode}}" #editstudentStudentMobCountryCode
                        class="form-control"
                        style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                        <option *ngFor="let code of countryCode" [value]="code.value"
                          [attr.data-countryCode]="code.countryCode">{{ code.countryName }} ({{ code.dialCode }})
                        </option>
                      </select>
                      <label for="addNewStudent-edit-countryCode-mother">{{ 'countryCode' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group">
                      <input (change)="editStudentChangeMotherNumber(editstudentMotherContact.value)"
                        id="edit-student-mothernum" #editstudentMotherContact type="text" class="form-control"
                        value="{{selectedStudentmothercontact}}" maxlength="10">
                      <label for="regular2">{{ 'contactNumber' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group">
                      <select #editstudentMotherOccupation name="select1" class="form-control"
                        style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                        <option value="0"></option>
                        <option value="Agriculture, Food and Natural Resources">{{ 'agricultureFoodAndNaturalResources' | translate }}
                        </option>
                        <option value="Architecture and Construction">{{ 'architectureAndConstruction' | translate }}</option>
                        <option value="Arts, Audio/Video Technology and Communications">{{ 'artsAudio/videoTechnologyAndCommunications' | translate }}</option>
                        <option value="Business Management and Administration">{{ 'businessManagementAndAdministration' | translate }}</option>
                        <option value="Education and Training">{{ 'educationAndTraining' | translate }}</option>
                        <option value="Finance">{{ 'finance' | translate }}</option>
                        <option value="Government and Public Administration">{{ 'governmentAndPublicAdministration' | translate }}
                        </option>
                        <option value="Health Science">{{ 'healthScience' | translate }}</option>
                        <option value="Hospitality and Tourism">{{ 'hospitalityAndTourism' | translate }}</option>
                        <option value="Human Services">{{ 'humanServices' | translate }}</option>
                        <option value="Information Technology">{{ 'informationTechnology' | translate }}</option>
                        <option value="Law, Public Safety, Corrections and Security">{{ 'lawPublicSafetyCorrectionsAndSecurity' | translate }}</option>
                        <option value="Manufacturing">{{ 'manufacturing' | translate }}</option>
                        <option value="Marketing, Sales and Service">{{ 'marketingSalesAndService' | translate }}</option>
                        <option value="Science, Technology, Engineering and Mathematics">{{ 'scienceTechnologyEngineeringAndMathematics' | translate }}</option>
                        <option value="Transportation, Distribution and Logistics">{{ 'transportationDistributionAndLogistics' | translate }}</option>
                        <option value="Others">{{ 'others' | translate }}</option>
                      </select>
                      <label for="regular2">{{ 'occupation' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <input (change)="editStudentMotherQualificationOnchange(editstudentMotherQualifiation.value)"
                        id="edit-student-motherqual" #editstudentMotherQualifiation type="text" class="form-control"
                        value="{{selectedStudentmotherqualification}}">
                      <label for="regular2">{{ 'educationalQualification' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <textarea (change)="editStudentMotherAddress(editstudentMotherAddress.value)"
                        id="edit-student-motheradd" #editstudentMotherAddress name="textarea1" class="form-control"
                        rows="3"
                        style="text-transform: initial;padding: 12px 10px;margin-top: 5px;">{{selectedStudentmotheraddress}}</textarea>
                      <label for="staddress">{{ 'contactAddress' | translate }}</label>
                    </div>
                  </div>
                </div>
                <!-- Guardian info -->
                <div class="row" style="margin: 0;">
                  <div class="col-md-12">
                    <h5>{{ 'guardiansInfo' | translate }}:</h5>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <input (change)="editStudentGuardianNameOnchange(editstudentGuardianName.value)"
                        id="edit-student-guardianname" #editstudentGuardianName type="text" class="form-control"
                        value="{{selectedStudentguardianname}}">
                      <label for="regular2">{{ 'guardiansName' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group">
                      <select id="addNewStudent-edit-countryCode-guardian" name="countrycodenewstueditguardian"
                        value="{{selectedStudentMobileCountryCode}}" #editstudentStudentMobCountryCode
                        class="form-control"
                        style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                        <option *ngFor="let code of countryCode" [value]="code.code"
                          [attr.data-countryCode]="code.country_code">
                          {{ code.name }} ({{ code.dial_code }})
                        </option>
                      </select>
                      <label for="addNewStudent-edit-countryCode-guardian">{{ 'countryCode' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group parentDetail">
                      <input (change)="editStudentGuardianNumberOnchange(editstudentGuardianContact.value)"
                        id="edit-student-guardiannum" #editstudentGuardianContact type="text" class="form-control"
                        value="{{selectedStudentguardiancontact}}" maxlength="10">
                      <label for="regular2">{{ 'contactNumber' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group">
                      <select #editstudentGuardianOccupation id="edit-student-gardian-occupation" name="select1"
                        class="form-control"
                        style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                        <option value="0"></option>
                        <option value="Agriculture, Food and Natural Resources">{{ 'agricultureFoodAndNaturalResources' | translate }}
                        </option>
                        <option value="Architecture and Construction">{{ 'architectureAndConstruction' | translate }}</option>
                        <option value="Arts, Audio/Video Technology and Communications">{{ 'artsAudio/videoTechnologyAndCommunications' | translate }}</option>
                        <option value="Business Management and Administration">{{ 'businessManagementAndAdministration' | translate }}
                        </option>
                        <option value="Education and Training">{{ 'educationAndTraining' | translate }}</option>
                        <option value="Finance">{{ 'finance' | translate }}</option>
                        <option value="Government and Public Administration">{{ 'governmentAndPublicAdministration' | translate }}
                        </option>
                        <option value="Health Science">{{ 'healthScience' | translate }}</option>
                        <option value="Hospitality and Tourism">{{ 'hospitalityAndTourism' | translate }}</option>
                        <option value="Human Services">{{ 'humanServices' | translate }}</option>
                        <option value="Information Technology">{{ 'informationTechnology' | translate }}</option>
                        <option value="Law, Public Safety, Corrections and Security">{{ 'lawPublicSafetyCorrectionsAndSecurity' | translate }}</option>
                        <option value="Manufacturing">{{ 'manufacturing' | translate }}</option>
                        <option value="Marketing, Sales and Service">{{ 'marketingSalesAndService' | translate }}</option>
                        <option value="Science, Technology, Engineering and Mathematics">{{ 'scienceTechnologyEngineeringAndMathematics' | translate }}</option>
                        <option value="Transportation, Distribution and Logistics">{{ 'transportationDistributionAndLogistics' | translate }}</option>
                        <option value="Others">{{ 'others' | translate }}</option>
                      </select>
                      <label for="regular2">{{ 'occupation' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <input (change)="editStudentGuardianQualificationOnchange(editstudentGuardianQualifiation.value)"
                        id="edit-student-guardianqual" #editstudentGuardianQualifiation type="text" class="form-control"
                        value="{{selectedStudentguardianqualification}}">
                      <label for="regular2">{{ 'educationalQualification' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <textarea (change)="editStudentGuardianAddressOnchange(editstudentGuardianAddress.value)"
                        id="edit-student-guardianadd" #editstudentGuardianAddress name="textarea1" class="form-control"
                        rows="3"
                        style="text-transform: initial;padding: 12px 10px;margin-top: 5px;">{{selectedStudentguardianaddress}}</textarea>
                      <label for="staddress">{{ 'contactAddress' | translate }}</label>
                    </div>
                  </div>
                </div>
                <!-- bus info -->
                <div class="row" style="margin: 0;min-height: 300px;" *ngIf="busStopListData.length>0">
                  <div class="col-md-12">
                    <h4 style="background: #f7f7f7;padding: 10px 10px;margin-top: 0;"  >{{ 'selectTransportOptions' | translate }} <a
                        (click)="clearTransportOptions()"
                        style="float: right;cursor: pointer; font-weight: normal;text-decoration: underline">{{ 'clearTransportOptions' | translate }}</a></h4>
                    <div class="col-md-6">
                      <div class="form-group">
                        <select id="bus-stop-selection-edit" (change)="updateSelectedBusStop($event.target.value)"
                          name="select1" class="form-control"
                          style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                          <option [value]="0">{{ 'notAssigned' | translate }}</option>
                          <option *ngFor="let o of busStopListData" [value]="o.PkBusStopId">{{o.BusStopName}}</option>
                        </select>
                        <label for="add-clname">{{ 'selectStop' | translate }}</label>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <select id="bus-selection-edit" (change)="updateSelectedBus($event.target.value)" name="select1"
                          class="form-control"
                          style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                          <option [value]="0">{{ 'notAssigned' | translate }}</option>
                          <option *ngFor="let o of busListData" [value]="o.pkBusId">{{o.BusName}} - {{o.BusNumber}} -
                            {{o.RouteName}}</option>
                        </select>
                        <label for="add-clname">{{ 'selectBus' | translate }}</label>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-group">
                        <input [(ngModel)]="mTotalBusFees" [ngModelOptions]="{standalone: true}" type="text"
                          class="form-control" id="regular1"
                          style="padding: 35px 10px;font-size: 20px;border: 1px dashed #e2e2e2;color: darkslategray;"
                          disabled="disabled">
                        <label for="regular1">{{ 'fare' | translate }}{{schoolCurrency}})</label>
                      </div>

                    </div>
                    <div *ngIf="isTermsVisible" id="edit_busterm_layout" class="col-md-12 animated fadeInUp">
                      <h5>{{ 'selectTerms' | translate }}:</h5>
                      <label class="checkbox-inline checkbox-styled">
                        <input type="checkbox" id="edit_student_select_all_terms"
                          (change)="onBusTermChangedSelectAllTerms_editStudent($event)"><span>{{ 'selectAllTerms' | translate }}</span>
                      </label>
                      <div>
                        <label *ngFor="let term of studentSelectedTerms" class="checkbox-inline checkbox-styled">
                          <input type="checkbox" [checked]="term.isSelectedTerm" [disabled]="!term.isEditable"
                            value="{{term.pkBusStopTermId}}"
                            (change)="onEditBusTermChanged($event,term)"><span>{{term.termName}} ({{'dueDate' | translate}}:
                            {{term.termDueDate | date}})</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" style="margin: 0;">
                  <div class="col-md-12 btn-group">
                    <button
                      (click)="updateSelectedStudentDetails(editstudentName.value,editstudentStudentClassId.value,editstudentSurname.value,editstudentStudentEmail.value,editstudentStudentContactnNumber.value,editstudentStudentDOB.value,editstudentStudentGenderMale.value,editstudentStudentGenderFemale.value,editstudentStudentAppStausConnected.value,editstudentStudentAppStausDisConnected.value,editstudentStudentAccountActive.value,editstudentStudentAccountDeActive.value,reasonForDeactiveStudent.value,editstudentFatherName.value,editstudentFatherContact.value,editstudentFatherOccupation.value,editstudentFatherQualifiation.value,editstudentFatherAddress.value,editstudentMotherName.value,editstudentMotherContact.value,editstudentMotherOccupation.value,editstudentMotherQualifiation.value,editstudentMotherAddress.value,editstudentGuardianName.value,editstudentGuardianContact.value,editstudentGuardianOccupation.value,editstudentGuardianQualifiation.value,editstudentGuardianAddress.value,editstudentStudentMobCountryCode.value)"
                      style="margin: 0px 5px;background: var(--secondary-btn-bg-color);border-color: var(--secondary-btn-bg-color);" type="button"
                      class="btn ink-reaction ink-reaction btn-info">{{ 'updateDetails' | translate }}</button>
                    <button style="margin: 0px 5px;background: var(--secondary-btn-bg-color);border-color: var(--secondary-btn-bg-color);" type="button"
                      class="btn ink-reaction ink-reaction btn-info" (click)="viewStudentOffcanvas()">{{ 'cancel' | translate }}</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <!-- End edit student off canvas -->
      <!--Fees Notification-->
      <div id="notificationForFees" class="modal fade" role="dialog">
        <div class="modal-dialog">
          <div class="modal-content" style="margin-top: 190px;height: 16em;">
            <div class="modal-body">
              <h3 style="margin: 0;font-weight: 100;color: #909090;"><i class="fa fa-check-square-o"
                  style="color:var(--secondary-btn-bg-color);"></i> {{ 'updateStudentDetail' | translate }}</h3>
              <button class="  btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal"
                style="background: var(--secondary-btn-bg-color);float: right;margin-top: -3em;margin-right: -2em;border: none;"
                type="button">×</button>
              <div class="col-md-12 text-center">
                <h5><b>{{selectedStudentname}}</b> {{ 'isAlreadyPaidInClass' | translate }} {{selectedStudentclassname}} -
                  {{selectedStudentclasssection}}</h5>
                <h5>{{ 'areYouConfirmToUpdate' | translate }} {{selectedStudentname}}{{ 'sClassAndDetails' | translate }}</h5>
              </div>
              <div class="col-md-12 text-center" style="padding:10px 0px;">
                <button (click)="confirmToUpdate()" class="btn btn-info btn-sm" style="width: 67px;">{{ 'ok' | translate }}</button>
                <button id="notificationpopupclose" class="btn btn-info btn-sm" data-dismiss="modal">{{ 'cancel' | translate }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--end of Fees Notification-->

      <!-- End Off canvas student section -->

      <!--Add staff offcanvas -->
      <div id="offcanvas-add-newstaff" class="offcanvas-pane width-12" style="width:800px;    overflow-x: hidden;">
        <div class="offcanvas-head" style="    padding: 0;">
          <div class="particles-view row" style="background: var(--secondary-btn-bg-color);min-height: 250px;">
            <div class="particles-content">
              <div class="col-md-12" style="position: fixed;z-index: 999;top: 0em;">
                <h3 id="closeAddStaff" class="pull-right" style="color: white;cursor: pointer;"
                  data-dismiss="offcanvas"><i class="fa fa-close"></i></h3>
              </div>
              <div class="col-md-12 text-center">
                <p class="lead text-center"
                  style="color: #ffffff;text-transform: uppercase; letter-spacing: 1px;margin-bottom: 10px;">{{ 'addStaff' | translate }}
                </p>
                <img src="assets/img/staff-symbol.png" class="img-responsive" style="margin: 0 auto;width: 75px;">
                <p style="margin: 15px 0px; color: white; font-weight: 100;">{{ 'addNewStaffDetailsHere' | translate }}</p>
              </div>
            </div>
          </div>
          <div class="row" style="background: #f1f1f1;">
            <div class="col-md-12">
              <h4 class="lead pull-left"
                style="margin: 10px 10px;color: #888888;letter-spacing: 1px;font-size: 12px;text-transform: uppercase;">
                {{ 'fillStaffDetails' | translate }}</h4>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12" style="padding: 15px 25px;">
              <form class="form student-detail-summary">
                <div class="row" style="margin: 0;">
                  <div class="col-md-3" style="margin-top: 1em;">
                    <div class="cropme-student-edit student-image"
                      style="width: 150px;min-height: 150px;float: initial;margin: 0 auto;border: 1px dashed  #e0e0e0;">
                      <img src="assets/img/avatar-students.png" id="staffimage" class="img-responsive">
                    </div>
                    <!--<h5 class="image-edit hide" style="text-align: center;display: inline-block;border: 1px solid #e2e2e2;  padding: 5px 5px;width: 150px;margin: 0px 0px 0px 8px; color: var(--secondary-btn-bg-color);  font-size: 9px;    text-transform: uppercase;">Click on the image to edit</h5>-->
                    <div class="col-md-12" style="text-align:center;">
                      <div class="col-md-12" style="text-align:center;">
                        <h5 class="progress hide" id="staff-progressbar"
                          style="text-align: center;cursor: pointer;display: inline-block;border: 1px solid #e2e2e2;padding: 9px 0px;margin: 1em -2em;color: var(--secondary-btn-bg-color);font-size: 9px;text-transform: uppercase;width: 150px;">
                          {{ 'uploading' | translate }}</h5>
                      </div>
                      <!--<div class="progress hide" id="progressbar">
               progressbar         <div id="prog " class="progress-bar progress-bar-striped active loading-bar-container"  role="progressbar"
                             aria-valuenow="40" aria-valuemin= "0" aria-valuemax="100" style="width:40%">
                          40%
                        </div>
                      </div>-->
                      <input type="file" class="input-style" id="staffuploadImage" style="width:1px; height: 1px">
                      <h5 (click)="openBrowserToUploadStaffPhoto()" id="hidetextbox" class="image-edit hide"
                        style="text-align: center;cursor: pointer;display: inline-block;border: 1px solid #e2e2e2;padding: 5px 0px;margin: -1em;color: var(--secondary-btn-bg-color);font-size: 9px;text-transform: uppercase;width: 150px;">
                        {{ 'uploadStaffImage' | translate }}</h5>
                    </div>
                  </div>
                  <div class="col-md-9">
                    <h5>{{ 'basicInfo' | translate }}:</h5>
                  </div>
                  <div class="col-md-9">
                    <div class="form-group">
                      <input (change)="AddStaffNameOnChange(addSelectedStaffName)" [(ngModel)]="addSelectedStaffName"
                        [ngModelOptions]="{standalone: true}" type="text" class="form-control" id="add-stfname"
                        placeholder="{{ 'enterStaffName' | translate }}" style="text-transform:initial;" maxlength="150">
                      <label for="add-stfname">{{ 'staffName' | translate }}<span style="color: #F44336;">*</span></label>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <input type="text" class="form-control addstaffDOB" id="add-dob" [(ngModel)]="addSelectedStaffDOB"
                        [ngModelOptions]="{standalone: true}" placeholder="{{ 'selectDOB' | translate}}" style="text-transform: initial;"
                        data-provide="datepicker" data-date-format="dd/mm/yyyy" data-date-end-date="0d">
                      <label for="add-dob">{{ 'dateOfBirthDd/mm/yyyy' | translate }}<span style="color: #F44336;">*</span></label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label>{{ 'gender' | translate }}</label>
                      <div class="btn-group addstaffGender" data-toggle="buttons" style="margin-top: 5px;">
                        <label class="btn ink-reaction btn-primary active" style="font-size: 10px;padding: 8px 10px;">
                          <input type="radio" name="options" value="1"><i class="fa fa-male fa-fw"></i> {{ 'male' | translate }}
                        </label>
                        <label class="btn ink-reaction btn-primary" style="font-size: 10px;padding: 8px 10px;">
                          <input type="radio" name="options" value="0"><i class="fa fa-female fa-fw"></i> {{ 'female' | translate }}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" style="margin: 0;margin-top: 10px;">
                  <div class="col-md-12">
                    <h5>{{ 'employmentDetails' | translate }}:</h5>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <select id="addstaffqual" name="select13" class="add-qualification form-control"
                        [(ngModel)]="addSelectedStaffQualification" style="border-bottom: 1px solid #e2e2e2;"
                        (change)="AddStaffOnChangeQualification(addSelectedStaffQualification)">
                        <option [value]="undefined">{{ 'selectQualification' | translate }}</option>
                        <option *ngFor="let qualification of staffQualificationListArray"
                          [value]="qualification.pkStaffQualificationId">{{qualification.Qualification}}</option>
                      </select>
                      <label>{{ 'selectQualification' | translate }}<span style="color: #F44336;">*</span></label>
                      <p id="add-qualification-new" data-placement="top" tabindex="0" data-toggle="popover"
                        data-container="body" data-trigger="focus" data-html="true"
                        data-content="<form class='form' style='margin: 5px 15px;'><div class='form-group'><p class='close-add-qualification' style='margin-top: -25px;font-size: 15px;color: #9e9e9e;cursor: pointer;z-index: 9999;text-align: right;position: absolute;width: 100%;'>x</p><div class='input-group'><div class='input-group-content'><input type='text' class='form-control' id='groupbutton9'><label for='groupbutton9'>Add new qualification</label></div><div class='input-group-btn'><button class='btn btn-default' type='button' style='background: var(--secondary-btn-bg-color);color: white;padding: 5px 30px;' id='addNewStaffQualificationpopover'>Add</button></div></div></div></form>">
                      </p>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <select id="addstaffdesig" name="select13" class="add-designation form-control"
                        [(ngModel)]="addSelectedStaffDesignation"
                        (change)="AddStaffOnChangeDesignation($event.target.value)">
                        <option [value]="undefined">{{ 'selectDesignation' | translate }}</option>
                        <option *ngFor="let designation of schoolDesignationList" [value]="designation.designationId">
                          {{designation.designation}}</option>
                      </select>
                      <label>{{ 'selectDesignation' | translate }}<span style="color: #F44336;">*</span></label>
                      <p id="add-designation-new" data-placement="top" tabindex="0" data-toggle="popover"
                        data-container="body" data-trigger="focus" data-html="true"
                        data-content="<form class='form' style='margin: 5px 15px;'><div class='form-group'><p class='close-add-designation' style='margin-top: -25px;font-size: 15px;color: #9e9e9e;cursor: pointer;z-index: 9999;text-align: right;position: absolute;width: 100%;'>x</p><div class='input-group'><div class='input-group-content'><input type='text' class='form-control' id='groupbutton9' ><label for='groupbutton9'>Add new designation</label></div><div class='input-group-btn'><button class='btn btn-default' type='button' style='background: var(--secondary-btn-bg-color);color: white;padding: 5px 30px;' >Add</button></div></div></div></form>">
                      </p>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <input (change)="AddStaffEmpIdOnChange(addSelectedStaffEmpId)" id="empId"
                        [(ngModel)]="addSelectedStaffEmpId" [ngModelOptions]="{standalone: true}" type="text"
                        class="form-control" placeholder="{{'enterEmployeeId' | translate}}" style="text-transform: initial;">
                      <label for="empId">{{ 'employeeId' | translate }}<span style="color: #F44336;">*</span></label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <input id="staffDoj" [(ngModel)]="addSelectedStaffDOJ" [ngModelOptions]="{standalone: true}"
                        type="text" class="form-control addstaffDOJ" placeholder="{{'enterJoiningDate' | translate}}"
                        style="text-transform: initial;" data-provide="datepicker" data-date-format="dd/mm/yyyy"
                        data-date-end-date="0d">
                      <label for="staffDoj">{{ 'dateOfJoiningDd/mm/yyyy' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <input placeholder="{{'enterAadharNumber' | translate}}" [(ngModel)]="addSelectedStaffAadharNumber"
                        name="aadharNumAddStf" id="add-staff-aadharNumber"
                        (keyup)="onChangeAadharNum('#add-staff-aadharNumber')" type="text" class="form-control"
                        maxlength="12">
                      <label for="add-staff-aadharNumber">{{ 'aadhar(uidNumber' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group" style="display: flex;">
                      <div class="col-md-12 hide" style="text-align:center;" id="new-staff-aadhar-progressbar-div">
                        <h5 class="progress" id="new-staff-aadhar-progressbar"
                          style="text-align: center;cursor: pointer;display: inline-block;border: 1px solid #e2e2e2;padding: 9px 0px;margin: 1em -2em;color: var(--secondary-btn-bg-color);font-size: 9px;text-transform: uppercase;width: 150px;">
                          {{ 'uploading' | translate }}</h5>
                      </div>
                      <img src="" id="new-staff-aadhar-image-ele" class="hide"
                        style="width: 63px;height: 40px;margin-top: 6px;">
                      <button id="new-staff-aadhar-copy-button" style="margin-top: 5px;margin-left: 7px"
                        (click)="openNewStaffAadharCopyUpload()"
                        class="btn-raised ink-reaction form-control">{{ 'upload' | translate }}</button>
                      <input (change)="startUploadingNewStaffAadharCopy()" style="width: 1px;height: 1px" type="file"
                        class="form-control hide" id="new-staff-aadhar-copy">
                      <label for="admission-phone-number">{{ 'aadharCopy' | translate }}</label>
                    </div>
                  </div>
                </div>
                <div class="row" style="margin: 0;margin-top: 10px;">
                  <div class="col-md-12">
                    <h5>{{ 'contactInfo' | translate }}: </h5>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <input type="text" id="mobile-number-add-staff" class="form-control" #mobileNumberStaff [ngClass]="{
                        'add-staff-mobile-number': !invalidAddStaffMobileNumber,
                        'add-staff-mobile-number-error': invalidAddStaffMobileNumber
                      }" [ngModelOptions]="{standalone: true}"
                        (input)="handleDebounceAddStaffMobileNumber(mobileNumberStaff)" pattern="[0-9]*" maxlength="20"
                        placeholder="{{ 'enterContactNumber' | translate}}" [(ngModel)]="addStaffMobileNumberInput"
                        (keydown)="handleKeyDown($event)" autocomplete="off" />
                      <label for="staffNo">{{ 'contactNumber' | translate }}<span style="color: #F44336;">*</span></label>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <input (change)="AddStaffEmailOnchange(addSelectedStaffEmail)" id="staffMail"
                        [(ngModel)]="addSelectedStaffEmail" [ngModelOptions]="{standalone: true}" type="text"
                        class="form-control" placeholder="{{ 'enterEmailAddress' | translate}}" style="text-transform: initial;">
                      <label for="staffMail">{{ 'emailAddress' | translate }}<span style="color: #F44336;">*</span></label>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <textarea (change)="AddStaffAddressOnchange(addSelectedStaffAddress)" id="staffAddress"
                        name="textarea1" [(ngModel)]="addSelectedStaffAddress" [ngModelOptions]="{standalone: true}"
                        class="form-control" rows="3" placeholder="{{ 'fillTheContactAddress' | translate }}"
                        style="padding: 10px 0px;text-transform: initial;"></textarea>
                      <label for="staddress">{{ 'contactAddress' | translate }}<span style="color: #F44336;">*</span></label>
                    </div>
                  </div>
                  <div class="col-md-12 btn-group">
                    <button id="add-staff-button" (click)="addNewStaffDetail()"
                      style="margin: 0px 5px;background: var(--secondary-btn-bg-color) !important;border-color: var(--secondary-btn-bg-color) !important;color: white !important;"
                      type="button" class="btn ink-reaction btn-raised btn-primary btn-loading-state disable-element"
                      data-loading-text="<i class='fa fa-spinner fa-spin'></i> Please wait...">{{ 'addDetails' | translate }}<div
                        class="ink" style="top: 10px; left: 59.5156px;"></div></button>
                    <button data-dismiss="offcanvas"
                      style="margin: 0px 5px;background: var(--secondary-btn-bg-color) !important;border-color: var(--secondary-btn-bg-color) !important;color: white !important;"
                      type="button" class="btn ink-reaction ink-reaction btn-danger disable-element">{{ 'cancel' | translate }}</button>
                    <div id="new-staff-progress-div" class="progress hide"
                      style="width: 300px;border-radius: 40px;    margin-top: 6px;">
                      <span id="new-staff-percent-text"
                        style="position: absolute;margin-left: 5%;color: #2b323a;width: 100%"></span>
                      <div id="new-staff-percent-progress"
                        class="progress-bar progress-bar-success progress-bar-striped active" role="progressbar"
                        aria-valuenow="40" aria-valuemin="0" aria-valuemax="100">
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <!-- End add staff off canvas -->

      <!--View staff offcanvas -->
      <div id="offcanvas-view-staff" class="offcanvas-pane width-12" style="width:800px;    overflow-x: hidden;">
        <div class="offcanvas-head" style="    padding: 0;">
          <div class="particles-view row" style="background: var(--secondary-btn-bg-color);min-height: 250px;">
            <div class="particles-content">
              <div class="col-md-12" style="position: fixed;z-index: 999;top: 0em;">
                <h3 class="pull-right" style="color: white;cursor: pointer;" data-dismiss="offcanvas"><i
                    class="fa fa-close"></i></h3>
              </div>
              <div class="col-md-12 text-center">
                <p class="lead text-center"
                  style="color: #ffffff;text-transform: uppercase; letter-spacing: 1px;margin-bottom: 10px;">{{ 'staffDetails' | translate }}</p>
                <img src="assets/img/staff-symbol.png" class="img-responsive" style="margin: 0 auto;width: 75px;">
                <p style="margin: 15px 0px; color: white; font-weight: 100;">{{ 'view' | translate }} <b>/</b> {{ 'manageTheStaffDetailsHere' | translate }}
                </p>
              </div>
            </div>
          </div>
          <div class="row" style="background: #f1f1f1;">
            <div class="col-md-12">
              <h4 class="lead pull-left"
                style="margin: 10px 10px;color: #888888;letter-spacing: 1px;font-size: 12px;text-transform: uppercase;">
                {{ 'selectedStaffDetails' | translate }}</h4>
              <div style="position: absolute;float: inherit;width: inherit;right: 2em;top: -12px;">
                <button type="button" *ngIf="permissions.UPDATE_STAFF == 'ENABLED'"
                  class="pull-right btn ink-reaction btn-floating-action btn-primary" (click)="editStaffOffcanvas();"
                  style="background: #E91E63;border: none;width: 60px;height: 60px;"><i
                    class="fa fa-pencil-square-o"></i></button>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12" style="padding: 15px 25px;">
              <form class="form student-detail-summary">
                <div class="row" style="margin: 0;">
                  <div class="col-md-3" style="margin-top: 1em;">
                    <div class=""
                      style="width: 150px;min-height: 150px;float: initial;margin: 0 auto;border: 1px dashed  #e0e0e0;">
                      <img src="{{selectedStaffImage}}" class="img-responsive">
                    </div>
                  </div>
                  <div class="col-md-9">
                    <h5>{{ 'basicInfo' | translate }}:</h5>
                  </div>
                  <div class="col-md-9">
                    <div class="form-group">
                      <input type="text" class="form-control" value="{{selectedStaffName}}" disabled>
                      <label for="add-stfname">{{ 'staffName' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <input disabled type="text" class="form-control"
                        value="{{selectedStaffDOB | date: 'MMM dd, yyyy '}}">
                      <label for="add-dob">{{ 'dateOfBirth' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label>{{ 'gender' | translate }}</label>
                      <div class="btn-group" data-toggle="buttons" style="margin-top: 5px;">
                        <label [attr.disabled]="true" class="btn ink-reaction btn-primary"
                          [class.active]="selectedStaffGender" style="font-size: 10px;padding: 8px 10px;">
                          <input type="radio" name="options"><i class="fa fa-male fa-fw"></i> {{ 'male' | translate }}
                        </label>
                        <label [attr.disabled]="true" class="btn ink-reaction btn-primary"
                          [class.active]="!selectedStaffGender" style="font-size: 10px;padding: 8px 10px;">
                          <input type="radio" name="options"><i class="fa fa-female fa-fw"></i> {{ 'female' | translate }}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" style="margin: 0;">
                  <div class="col-md-6">
                    <h5>{{ 'bluewingsAppStatus' | translate }}:</h5>
                    <div class="col-md-12" style="padding: 5px;border: 1px solid #e8e8e8;">
                      <div class="">
                        <label class="radio-inline radio-styled">
                          <input [attr.disabled]="!selectedStaffAppStatus ? true : null" type="radio"
                            name="add-app-status"
                            [attr.checked]="selectedStaffAppStatus ? true : null"><span>{{ 'connected' | translate }}</span>
                        </label>
                        <label class="radio-inline radio-styled">
                          <input [attr.disabled]="selectedStaffAppStatus ? true : null" type="radio"
                            name="add-app-status"
                            [attr.checked]="!selectedStaffAppStatus ? true : null"><span>{{ 'disconnected' | translate }}</span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <h5>{{ 'accountStatus' | translate }}:</h5>
                    <div class="col-md-12" style="padding: 5px;border: 1px solid #e8e8e8;">
                      <div class="">
                        <label class="radio-inline radio-styled">
                          <input [attr.disabled]="!selectedStaffAccStatus ? true : null" type="radio"
                            name="account-status"
                            [attr.checked]="selectedStaffAccStatus ? true : null"><span>{{ 'active' | translate }}</span>
                        </label>
                        <label class="radio-inline radio-styled">
                          <input [attr.disabled]="selectedStaffAccStatus ? true : null" type="radio"
                            name="account-status"
                            [attr.checked]="!selectedStaffAccStatus ? true : null"><span>{{ 'deactive' | translate }}</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" style="margin: 0;margin-top: 10px;">
                  <div class="col-md-12">
                    <h5>{{ 'employmentDetails' | translate }}:</h5>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <input id="qualif" type="text" class="form-control" disabled
                        value="{{selectedStaffQualification}}">
                      <label for="qualif">{{ 'qualification' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <input id="desg" type="text" class="form-control" disabled value="{{selectedStaffDesignation}}">
                      <label for="desg">{{ 'designation' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <input id="staffEmp" type="text" class="form-control" disabled value="{{selectedStaffEmpId}}">
                      <label for="staffEmp">{{ 'employeeId' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <input id="Doj" type="text" class="form-control" disabled
                        value="{{selectedStaffDOJ | date: 'MMM dd, yyyy '}}">
                      <label for="Doj">{{ 'dateOfJoining' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <input disabled value="{{selectedStaffAadharNumber}}" name="aadharNumAddStf"
                        id="view-staff-aadharNumber" type="text" class="form-control" maxlength="12">
                      <label for="view-staff-aadharNumber">{{ 'aadhar(uidNumber' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-3 hide" id="view-staff-aadhar-image-id">
                    <div class="form-group" style="display: flex;">
                      <img src="" id="view-staff-aadhar-image-ele" style="width: 63px;height: 40px;margin-top: 3px;">
                      <label for="admission-phone-number">{{ 'aadharCopy' | translate }}</label>
                    </div>
                  </div>
                </div>
                <div class="row" style="margin: 0;margin-top: 10px;">
                  <div class="col-md-12">
                    <h5>{{ 'contactInfo' | translate }}:</h5>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                        <input type="text" name="mobile-number-edit-staff"  class="form-control edit-staff-mobile-number" 
                          [ngModelOptions]="{standalone: true}" 
                          maxlength="20" [placeholder]="'enterContactNumber' | translate" [(ngModel)]="editSelectedStaffContact"
                           disabled />
                      <label for="mob">{{ 'contactNumber' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <input id="mail" type="text" class="form-control" disabled value="{{selectedStaffEmail}}"
                        style="text-transform:initial;">
                      <label for="mail">{{ 'emailAddress' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <textarea disabled="" name="textarea1" class="form-control" rows="3"
                        [placeholder]="'fillTheContactAddress' | translate"
                        style="padding: 10px 25px;text-transform: initial;">{{selectedStaffAddress}}</textarea>
                      <label for="staddress">{{ 'contactAddress' | translate }}</label>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <!-- End view staff off canvas -->

      <!--Edit staff offcanvas -->
      <div id="offcanvas-edit-staff" class="offcanvas-pane width-12" style="width:800px;    overflow-x: hidden;">
        <div class="offcanvas-head" style="    padding: 0;">
          <div class="particles-view row" style="background: var(--secondary-btn-bg-color);min-height: 250px;">
            <div class="particles-content">
              <div class="col-md-12" style="position: fixed;z-index: 999;top: 0em;">
                <h3 id="closeUpdateStaff" class="pull-right" style="color: white;cursor: pointer;"
                  data-dismiss="offcanvas"><i class="fa fa-close"></i></h3>
              </div>
              <div class="col-md-12 text-center">
                <p class="lead text-center"
                  style="color: #ffffff;text-transform: uppercase; letter-spacing: 1px;margin-bottom: 10px;">{{ 'editStaff' | translate }}
                </p>
                <img src="assets/img/staff-symbol.png" class="img-responsive" style="margin: 0 auto;width: 75px;">
                <p style="margin: 15px 0px; color: white; font-weight: 100;">{{ 'editDetailsOfTheSelectedStaff' | translate }}</p>
              </div>
            </div>
          </div>
          <div class="row" style="background: #f1f1f1;">
            <div class="col-md-12">
              <h4 class="lead pull-left"
                style="margin: 10px 10px;color: #888888;letter-spacing: 1px;font-size: 12px;text-transform: uppercase;">
                {{ 'editStaffDetails' | translate }}</h4>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12" style="padding: 15px 25px;">
              <form class="form student-detail-summary">
                <div class="row" style="margin: 0;">
                  <div class="col-md-3" style="margin-top: 1em;">
                    <div class=""
                      style="width: 150px;min-height: 150px;float: initial;margin: 0 auto;border: 1px dashed  #e0e0e0;">
                      <img src="{{selectedStaffImage}}" id="staffimagedit" class="img-responsive">
                    </div>
                    <div class="col-md-12" style="text-align:center;">
                      <div class="col-md-12" style="text-align:center;">
                        <h5 class="progress hide" id="staffedit-progressbar"
                          style="text-align: center;cursor: pointer;display: inline-block;border: 1px solid #e2e2e2;padding: 9px 0px;margin: 1em -2em;color: var(--secondary-btn-bg-color);font-size: 9px;text-transform: uppercase;width: 150px;">
                          {{ 'uploading' | translate }}</h5>
                      </div>
                      <input type="file" class="input-style " id="openbrowserstaffedit" style="width:1px; height: 1px">
                      <h5 (click)="openbrowsertouplaodEditStaffphoto()" class="image-edit hide" id="hideforstaffedit"
                        style="text-align: center;cursor: pointer;display: inline-block;border: 1px solid #e2e2e2;padding: 5px 0px;margin: -1em;color: var(--secondary-btn-bg-color);font-size: 9px;text-transform: uppercase;width: 150px;">
                        {{ 'updateStaffImage' | translate }}</h5><i id="trashIcon" class="fas fa-trash cursor-pointer"
                        style="color: #F44336;" data-toggle="modal" data-target="#deleteStaffPopup"></i>
                    </div>
                  </div>
                  <div class="col-md-9">
                    <h5>{{ 'basicInfo' | translate }}:</h5>
                  </div>
                  <div class="col-md-9">
                    <div class="form-group">
                      <input (change)="staffNameOnChange()" id="staffnameborderredname"
                        [(ngModel)]="editSelectedStaffName" [ngModelOptions]="{standalone: true}" type="text"
                        class="form-control" value="{{selectedStaffName}}">
                      <label for="add-stfname">{{ 'staffName' | translate }}<span style="color: #F44336;">*</span></label>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <input id="staffnameborderreddob" type="text" class="form-control staff-edit-dob"
                        [placeholder]="'selectDOJ' | translate" style="text-transform: initial;" data-provide="datepicker"
                        data-date-format="dd/mm/yyyy" data-date-end-date="0d"
                        value="{{selectedStaffDOB | date: 'dd/MM/y'}}">
                      <label for="add-dob">{{ 'dateOfBirthDd/mm/yy' | translate }}<span style="color: #F44336;">*</span></label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label>{{ 'gender' | translate }}</label>
                      <div class="btn-group staff-edit-gender" data-toggle="buttons" style="margin-top: 5px;">
                        <label id="editstaffmale" class="btn ink-reaction btn-primary"
                          [class.active]="selectedStaffGender" style="font-size: 10px;padding: 8px 10px;">
                          <input type="radio" class="gender" name="options"><i class="fa fa-male fa-fw"></i> {{ 'male' | translate }}
                        </label>
                        <label id="editstaffemale" class="btn ink-reaction btn-primary"
                          [class.active]="!selectedStaffGender" style="font-size: 10px;padding: 8px 10px;">
                          <input type="radio" class="gender" name="options"><i class="fa fa-female fa-fw"></i> {{ 'female' | translate }}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" style="margin: 0;">
                  <div class="col-md-6">
                    <h5>{{ 'bluewingsAppStatus' | translate }}:</h5>
                    <div class="col-md-12" style="padding: 5px;border: 1px solid #e8e8e8;">
                      <div class="staff-edit-appstatus">
                        <label class="radio-inline radio-styled">
                          <input id="appstatus" #editstaffAccountActive type="radio" name="add-app-status"
                            [attr.checked]="selectedStaffAppStatus ? true : null" value="1"
                            class="radiobutton1"><span>{{ 'connected' | translate }}</span>
                        </label>
                        <label class="radio-inline radio-styled">
                          <input id="appstatus2" #editstaffAccountDeActive type="radio" name="add-app-status"
                            [attr.checked]="selectedStaffAppStatus == false ? true : null" value="0"
                            class="radiobutton1"><span>{{ 'disconnected' | translate }}</span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <h5>{{ 'accountStatus' | translate }}:</h5>
                    <div class="col-md-12" style="padding: 5px;border: 1px solid #e8e8e8;">
                      <div class="edit-staff-accstatus">
                        <label class="radio-inline radio-styled">
                          <input id="accstatus" (change)="editStaffDeactiveStateChange('active')"
                            #editstaffAccountIsblocked type="radio" name="account-status"
                            [attr.checked]="selectedStaffAccStatus ? true : null" value="1"
                            class="radiobutton1"><span>{{ 'active' | translate }}</span>
                        </label>
                        <label class="radio-inline radio-styled">
                          <input id="accstatus2" (change)="editStaffDeactiveStateChange('block')"
                            #editstaffAccountBlocked type="radio" name="account-status"
                            [attr.checked]="!selectedStaffAccStatus ? true : null" value="0"
                            class="radiobutton1"><span>{{ 'deactive' | translate }}</span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div id="reasonStaff" class="col-md-6 col-md-offset-6 hide">
                    <div class="form-group">
                      <input type="text" id="edit-staff-deactive-reason-input" class="form-control">
                      <label for="edit-staff-deactive-reason-input">{{ 'reason' | translate }}<span style="color: #F44336;">*</span></label>
                    </div>
                  </div>
                </div>
                <div class="row" style="margin: 0;margin-top: 10px;">
                  <div class="col-md-12">
                    <h5>{{ 'employmentDetails' | translate }}:</h5>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label>{{ 'qualification' | translate }}<span style="color: #F44336;">*</span></label>
                      <select name="select13" id="qualification" [(ngModel)]="selectedStaffQualificationId"
                        [ngModelOptions]="{standalone: true}" class="form-control"
                        style="text-transform: uppercase;border-bottom: 1px solid #e2e2e2;"
                        (change)="editStaffQualification($event.target.value)">
                        <option *ngFor="let qualification of staffQualificationListArray"
                          value="{{qualification.pkStaffQualificationId}}">{{qualification.Qualification}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label>{{ 'designation' | translate }}<span style="color: #F44336;">*</span></label>
                      <select name="select13" id="designation" [(ngModel)]="selectedStaffDesignationId"
                        [ngModelOptions]="{standalone: true}" class="form-control"
                        (change)="editStaffDesignation($event.target.value)">
                        <option *ngFor="let designation of schoolDesignationList" value="{{designation.designationId}}">
                          {{designation.designation}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <input (change)="staffEmpIdOnChange()" name="empd" id="staffnameborderredempid"
                        [(ngModel)]="editSelectedStaffEmpId" [ngModelOptions]="{standalone: true}" type="text"
                        class="form-control" value="{{selectedStaffEmpId}}">
                      <label for="staffnameborderredempid">{{ 'employeeId' | translate }}<span style="color: #F44336;">*</span></label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <input id="staffnameborderreddoj" type="text" class="form-control edit-staff-doj"
                        [placeholder]="'selectDOJ' | translate" style="text-transform: initial;" data-provide="datepicker"
                        data-date-format="dd/mm/yyyy" data-date-end-date="0d"
                        value="{{selectedStaffDOJ | date: 'dd/MM/y'}}">
                      <label for="staffnameborderreddoj">{{ 'dateOfJoiningDd/mm/yy' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <input [placeholder]="'enterAadharNumber' | translate" [(ngModel)]="editSelectedStaffAadharNumber"
                        name="aadharNumEditStf" id="edit-staff-aadharNumber"
                        (keyup)="onChangeAadharNum('#edit-staff-aadharNumber')" type="text" class="form-control"
                        maxlength="12">
                      <label for="edit-staff-aadharNumber">{{ 'aadhar(uidNumber' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group" style="display: flex;">
                      <div class="col-md-12 hide" style="text-align:center;" id="edit-staff-aadhar-progressbar-div">
                        <h5 class="progress" id="edit-staff-aadhar-progressbar"
                          style="text-align: center;cursor: pointer;display: inline-block;border: 1px solid #e2e2e2;padding: 9px 0px;margin: 1em -2em;color: var(--secondary-btn-bg-color);font-size: 9px;text-transform: uppercase;width: 150px;">
                          {{ 'uploading' | translate }}</h5>
                      </div>
                      <img src="" id="edit-staff-aadhar-image-ele" style="width: 63px;height: 40px;margin-top: 6px;">
                      <button id="edti-staff-aadhar-copy-button" style="margin-top: 5px;margin-left: 7px"
                        (click)="openEditStaffAadharCopyUpload()"
                        class="btn-raised ink-reaction form-control">{{ 'upload' | translate }}</button>
                      <input (change)="startUploadingEditStaffAadharCopy()" style="width: 1px;height: 1px" type="file"
                        class="form-control hide" id="edit-staff-aadhar-copy">
                      <label for="admission-phone-number">{{ 'aadharCopy' | translate }}</label>
                    </div>
                  </div>
                </div>
                <div class="row" style="margin: 0;margin-top: 10px;">
                  <div class="col-md-12">
                    <h5>{{ 'contactInfo' | translate }}</h5>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="staffnameborderredcontact">{{ 'contactNumber' | translate }}:<span
                          style="color: #F44336;">*</span></label>
                      <input type="text" name="mobile-number-edit-staff" class="form-control" #mobileNumberEditStaff
                        [ngModelOptions]="{standalone: true}" [ngClass]="{
                            'edit-staff-mobile-number': !invalidEditStaffMobileNumber,
                            'edit-staff-mobile-number-error': invalidEditStaffMobileNumber
                          }" (input)="handleDebounceEditStaffMobileNumber(mobileNumberEditStaff)" pattern="[0-9]*"
                        maxlength="20" [placeholder]="'enterContactNumber' | translate" [(ngModel)]="editSelectedStaffContact"
                        (keydown)="handleKeyDown($event)" autocomplete="off"
                      />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <input (change)="staffEmailOnchange(editSelectedStaffEmail)" id="staffnameborderredemail"
                        [(ngModel)]="editSelectedStaffEmail" [ngModelOptions]="{standalone: true}" type="text"
                        class="form-control" value="{{selectedStaffEmail}}" style="text-transform:initial;">
                      <label for="staffnameborderredemail">{{ 'emailAddress' | translate }}<span style="color: #F44336;">*</span></label>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <textarea (change)="staffAddressOnchange()" id="staffnameborderredaddress"
                        [(ngModel)]="editSelectedStaffAddress" [ngModelOptions]="{standalone: true}" name="textarea1"
                        class="form-control" rows="3" [placeholder]="'fillTheContactAddress' | translate"
                        style="padding: 10px 25px;text-transform: initial;">{{selectedStaffAddress}}</textarea>
                      <label for="staddress">{{ 'contactAddress' | translate }}<span style="color: #F44336;">*</span></label>
                    </div>
                  </div>
                  <div class="col-md-12 btn-group">
                    <button (click)="updateStaffDetails()"
                      style="margin: 0px 5px;background: var(--secondary-btn-bg-color) !important;border-color: var(--secondary-btn-bg-color) !important;color: white !important;"
                      type="button" class="btn ink-reaction btn-raised btn-primary btn-loading-state"
                      data-loading-text="<i class='fa fa-spinner fa-spin'></i> Please wait...">{{ 'updateDetails' | translate }}{{ 's' | translate }}<div
                        class="ink" style="top: 10px; left: 59.5156px;"></div></button>
                    <button
                      style="margin: 0px 5px;background: var(--secondary-btn-bg-color) !important;border-color: var(--secondary-btn-bg-color) !important;color: white !important;"
                      type="button" class="btn ink-reaction btn-raised btn-primary"
                      (click)="viewStaffOffcanvas()">{{ 'cancel' | translate }}</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <!-- End Edit staff off canvas -->

      <!--Staff designation offcanvas -->
      <div id="offcanvas-staff-desgnation" class="offcanvas-pane width-12" style="width:800px;    overflow-x: hidden;">
        <div class="offcanvas-head" style="padding: 0;">
          <div class="particles-view row" style="background: var(--secondary-btn-bg-color);min-height: 250px;">
            <div class="particles-content">
              <div class="col-md-12" style="position: fixed;z-index: 999;top: 0em;">
                <h3 class="pull-right" style="color: white;cursor: pointer;" data-dismiss="offcanvas"><i
                    class="fa fa-close"></i></h3>
              </div>
              <div class="col-md-12 text-center">
                <p class="lead text-center"
                  style="color: #ffffff;text-transform: uppercase; letter-spacing: 1px;margin-bottom: 10px;">{{ 'manageDesignation' | translate }}</p>
                <img src="assets/img/staff-symbol.png" class="img-responsive" style="margin: 0 auto;width: 75px;">
                <p style="margin: 15px 0px; color: white; font-weight: 100;">{{ 'add' | translate }} <b>/</b> {{ 'manageStaffDesignation' | translate }}</p>
                <p class="lead"
                  style="color: white; font-size: 15px; border: 1px solid;    display: inline-block;    padding: 5px 15px;">
                  {{ 'getStarted' | translate }} &nbsp;&nbsp;&nbsp;<i class="fa fa-chevron-down"></i></p>
              </div>
            </div>
          </div>
          <div class="row" style="background: #f1f1f1;">
            <div class="col-md-12">
              <h4 class="lead pull-left"
                style="margin: 10px 10px;color: #888888;letter-spacing: 1px;font-size: 12px;text-transform: uppercase;">
                {{ 'manageStaffDesignation' | translate }}</h4>
            </div>
          </div>
          <div class="row" style="background: #fdfdfd;">
            <div class="col-md-12 card" style="padding-bottom: 1em;margin-bottom: 0px;">
              <div class="col-md-12" style="border-bottom: 1px solid #d8d8d8;margin-bottom: 20px;">
                <h5>{{ 'addNewDesignation' | translate }}</h5>
              </div>
              <div class="form-group">
                <div class="col-md-12 text-center">
                  <p class=""
                    style="color: #a0a0a0;font-weight: 100;font-size: 12px;display: inline-block;margin: 0px 10px;">
                    {{ 'selectBluewingsAppAccessLevel' | translate }}</p>
                </div>
                <div class="col-md-10 col-md-offset-1 text-center" style="margin-bottom: 15px;">
                  <label class="checkbox-inline checkbox-styled">
                    <input (change)="addDesigSuperadminAccess($event)" [(ngModel)]="superAdminAccess" type="checkbox"
                      value="option1">
                    <span data-toggle="tooltip" data-placement="top" title=""
                      data-original-title="As a Super admin you have complete control of application: You can manage broadcast messages (approve, reject),create and view diary of all classes and chat with all parents.">{{ 'superAdmin' | translate }}</span>
                  </label>
                  <label class="checkbox-inline checkbox-styled">
                    <input (change)="addDesigFinanceadminAccess($event)" [(ngModel)]="financeAdminAccess"
                      type="checkbox" value="option1">
                    <span data-toggle="tooltip" data-placement="top" title=""
                      data-original-title="As a Finance admin you can view school financial activity.">{{ 'financeAdmin' | translate }}</span>
                  </label>
                  <label class="checkbox-inline checkbox-styled">
                    <input (change)="addDesignationFeeDefaulterManager($event)" [(ngModel)]="feeDafaulterViewAccass"
                      type="checkbox" value="option1">
                    <span data-toggle="tooltip" data-placement="top" title=""
                      data-original-title="As a Fee defaulter admin you can view all defaulter list of class as per your designation.">{{ 'feeDefaulterManager' | translate }}</span>
                  </label>
                  <label class="checkbox-inline checkbox-styled">
                    <input (change)="addDesigTeacherAccess($event)" [(ngModel)]="classTeacherAccess" type="checkbox"
                      value="option1"><span data-toggle="tooltip" data-placement="top" title=""
                      data-original-title="As a Class teacher you have class level permissions: You can create, edit diaries for all the subjects and you can chat with all parents for your class.">{{ 'classTeacher' | translate }}</span>
                  </label>
                  <label class="checkbox-inline checkbox-styled">
                    <input (change)="addDesigDriverAccess($event)" [(ngModel)]="driverAccess" type="checkbox"
                      value="option1"><span data-toggle="tooltip" data-placement="top" title=""
                      data-original-title="Marking a designation as a Driver will recognise that staff is a Diver.">{{ 'driver' | translate }}</span>
                  </label>
                  <label class="checkbox-inline checkbox-styled">
                    <input type="checkbox" value="option1" checked=""><span data-toggle="tooltip" data-placement="top"
                      title=""
                      data-original-title="By default you are eligible to view timetable, view broadcasts messages, view diaries and chat with parents of your class.">{{ 'default' | translate }}</span>
                  </label>
                </div>
              </div>
              <form class="form col-md-10 col-md-offset-1">
                <div class="form-group">
                  <div class="input-group">
                    <div class="input-group-content">
                      <input id="groupbutton19" type="text" class="form-control" [(ngModel)]="addNewDesignationTitle"
                        [ngModelOptions]="{standalone: true}">
                      <label for="groupbutton19" class="">{{ 'designation' | translate }}</label>
                    </div>
                    <div class="input-group-btn">
                      <button *ngIf="!editDesignationState" (click)="isLoading ? '' : addNewStaffDesignation()"
                        style="margin: 0px 5px;background: var(--secondary-btn-bg-color) !important;border-color: var(--secondary-btn-bg-color) !important;color: white !important;"
                        type="button" class="btn ink-reaction btn-raised btn-primary btn-loading-state"><span>{{ 'addDesignation' | translate }}</span>&nbsp;<span *ngIf="isLoading"><i class='fa fa-spinner fa-spin'></i></span>
                        <div class="ink" style="top: 10px; left: 59.5156px;"></div>
                      </button>
                      <button *ngIf="editDesignationState" (click)="isLoading ? '' : editDesignationSubmit()"
                        style="margin: 0px 5px;background: var(--secondary-btn-bg-color) !important;border-color: var(--secondary-btn-bg-color) !important;color: white !important;"
                        type="button"
                        class="btn ink-reaction btn-raised btn-primary btn-loading-state"><span>{{ 'update' | translate }}</span>&nbsp;<span
                          *ngIf="isLoading"><i class='fa fa-spinner fa-spin'></i>{{ 'pleaseWait' | translate }}</span>
                        <div class="ink" style="top: 10px; left: 59.5156px;"></div>
                      </button>
                      <button *ngIf="editDesignationState" (click)="isLoading ? '' : cancelEditDesignation()"
                        style="margin: 0px 5px;background: var(--secondary-btn-bg-color) !important;border-color: var(--secondary-btn-bg-color) !important;color: white !important;"
                        type="button"
                        class="btn ink-reaction btn-raised btn-primary btn-loading-state"><span>{{ 'cancel' | translate }}</span>
                        <div class="ink" style="top: 10px; left: 59.5156px;"></div>
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="col-md-12 card" style="padding-bottom: 5em;margin-bottom: 0;">
              <div class="col-md-12"
                style="border-top: 1px solid #eaeaea;background: #f7f7f7;border-bottom: 1px solid #eaeaea;">
                <h5>{{ 'designationList' | translate }}</h5>
              </div>
              <div class="col-md-12" style="padding: 0;">
                <div class="card-body no-padding">
                  <ul class="list divider-full-bleed">
                    <li class="tile" style="padding: 15px 0px;" *ngFor="let designation of schoolDesignationList">
                      <a class="tile-content ink-reaction">
                        <div class="tile-text" style="display: inline;"><i class="fa fa-circle desig-indicator"></i>
                          {{designation.designation}}</div>
                        <div class="bootstrap-tagsinput" style="display: block;margin-left: 35px;">
                          <p style="margin: 0;display: inline-block;font-size: 11px;margin-right: 5px; color: #969696;">
                            {{ 'bluewingsAppAccessLevel' | translate }}</p>
                          <span class="tag label label-info">{{ 'default' | translate }}</span>
                          <span class="tag label label-info" *ngIf="designation.isSuperAdmin">{{ 'superAdmin' | translate }}</span>
                          <span class="tag label label-info" *ngIf="designation.isFinanceAdmin">{{ 'financeAdmin' | translate }}</span>
                          <span class="tag label label-info" *ngIf="designation.isFeeDefaulterAdmin">{{ 'feeDefaulterManager' | translate }}</span>
                          <span class="tag label label-info" *ngIf="designation.isClassTeacher">{{ 'teacher' | translate }}</span>
                          <span class="tag label label-info" *ngIf="designation.isDriver">{{ 'driver' | translate }}</span>
                        </div>
                      </a>
                      <a class="btn btn-flat ink-reaction">
                        <i class="fa fa-edit" (click)="editDesignation(designation)"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End Staff designation off canvas -->

      <!--Staff qualification offcanvas -->
      <div id="offcanvas-staff-qualification" class="offcanvas-pane width-12"
        style="width:800px;    overflow-x: hidden;">
        <div class="offcanvas-head" style="    padding: 0;">
          <div class="particles-view row" style="background: var(--secondary-btn-bg-color);min-height: 250px;">
            <div class="particles-content">
              <div class="col-md-12" style="position: fixed;z-index: 999;top: 0em;">
                <h3 class="pull-right" style="color: white;cursor: pointer;" data-dismiss="offcanvas"><i
                    class="fa fa-close"></i></h3>
              </div>
              <div class="col-md-12 text-center">
                <p class="lead text-center"
                  style="color: #ffffff;text-transform: uppercase; letter-spacing: 1px;margin-bottom: 10px;">{{ 'manageQualification' | translate }}</p>
                <img src="assets/img/staff-symbol.png" class="img-responsive" style="margin: 0 auto;width: 75px;">
                <p style="margin: 15px 0px; color: white; font-weight: 100;">{{ 'add' | translate }} <b>/</b> {{ 'manageStaffQualification' | translate }}</p>
                <p class="lead"
                  style="color: white; font-size: 15px; border: 1px solid;    display: inline-block;    padding: 5px 15px;">
                  {{ 'getStarted' | translate }} &nbsp;&nbsp;&nbsp;<i class="fa fa-chevron-down"></i></p>
              </div>
            </div>
          </div>
          <div class="row" style="background: #f1f1f1;">
            <div class="col-md-12">
              <h4 class="lead pull-left"
                style="margin: 10px 10px;color: #888888;letter-spacing: 1px;font-size: 12px;text-transform: uppercase;">
                {{ 'manageStaffQualification' | translate }}</h4>
            </div>
          </div>
          <div class="row" style="background: #fdfdfd;">
            <div class="col-md-12 card" style="padding-bottom: 1em;margin-bottom: 0px;">
              <div class="col-md-12" style="border-bottom: 1px solid #d8d8d8;margin-bottom: 20px;">
                <h5>{{ 'addNewQualification' | translate }}</h5>
              </div>
              <form class="form col-md-10 col-md-offset-1">
                <div class="form-group">
                  <div class="input-group">
                    <div class="input-group-content">
                      <input [(ngModel)]="addNewQualificationTitle" [ngModelOptions]="{standalone: true}" type="text"
                        class="form-control groupbutton9_focus" id="groupbutton9">
                      <label for="groupbutton9" class="">{{ 'qualification' | translate }}</label>
                    </div>
                    <div class="input-group-btn">
                      <button *ngIf="!editQualificationState" (click)="addNewStaffQualification()"
                        style="margin: 0px 5px;background: var(--secondary-btn-bg-color) !important;border-color: var(--secondary-btn-bg-color) !important;color: white !important;"
                        type="button" class="btn ink-reaction btn-raised btn-primary btn-loading-state">{{ 'addQualification' | translate }} &nbsp;<i *ngIf="isLoading" class='fa fa-spinner fa-spin'></i>
                        <div class="ink" style="top: 10px; left: 59.5156px;"></div>
                      </button>
                      <button *ngIf="editQualificationState" (click)="editStaffQualificationList()"
                        style="margin: 0px 5px;background: var(--secondary-btn-bg-color) !important;border-color: var(--secondary-btn-bg-color) !important;color: white !important;"
                        type="button" class="btn ink-reaction btn-raised btn-primary btn-loading-state">{{ 'update' | translate }} &nbsp;<i
                          *ngIf="isLoading" class='fa fa-spinner fa-spin'></i>
                        <div class="ink" style="top: 10px; left: 59.5156px;"></div>
                      </button>
                      <button *ngIf="editQualificationState" (click)="cancelEditQualification()"
                        style="margin: 0px 5px;background: var(--secondary-btn-bg-color) !important;border-color: var(--secondary-btn-bg-color) !important;color: white !important;"
                        type="button" class="btn ink-reaction btn-raised btn-primary btn-loading-state">{{ 'cancel' | translate }} &nbsp;<i
                          *ngIf="isLoading" class='fa fa-spinner fa-spin'></i>
                        <div class="ink" style="top: 10px; left: 59.5156px;"></div>
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="col-md-12 card" style="padding-bottom: 5em;margin-bottom: 0;">
              <div class="col-md-12"
                style="border-top: 1px solid #eaeaea;background: #f7f7f7;border-bottom: 1px solid #eaeaea;">
                <h5>{{ 'qualificationList' | translate }}</h5>
              </div>
              <div class="col-md-12" style="padding: 0;">
                <div class="card-body no-padding">
                  <ul class="list divider-full-bleed">
                    <li class="tile" *ngFor="let qualification of staffQualificationListArray">
                      <a class="tile-content ink-reaction">
                        <div class="tile-text">
                          {{qualification.Qualification}}
                        </div>
                        <div class="tile-icon">
                          <i style="cursor: pointer" class="fa fa-edit"
                            (click)="startEditQualification(qualification)"></i>
                          <span class="qualification hidden">{{qualification.pkStaffQualificationId}}</span>
                        </div>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <app-student-deactivate *ngIf="openStudentDeactivatePopup" (save_button_event)="afterStudentDeactivated()"
        (closePopup)="studentDeactivatePopupClose()" [visible]="openStudentDeactivatePopup ? 'block' : 'none'"
        [studentName]="studentDeactivatePopupStudentName"
        [studentId]="studentDeactivatePopupStudentId"  [studentSelectedAcademicYear] = "academicInfo.current_academic"></app-student-deactivate>
      <app-student-transport-settings-popup *ngIf="openStudentTransportOptionSettingsPopup" [currType]="schoolCurrency"
        (save_button_event)="afterTransportOptionsSaved()" (closePopup)="transportOptionsPopupClose()"
        [button_text]="'save' | translate" [visible]="openStudentTransportOptionSettingsPopup ? 'block' : 'none'"
        [studentName]="studentDeactivatePopupStudentName" [studentId]="studentDeactivatePopupStudentId"
        [academicId]="academicId"></app-student-transport-settings-popup>
      <app-student-basic-info *ngIf="openStudentBasicInfoPopup" (save_button_event)="afterStudentBasicInfoSaved()"
        (closePopup)="studentBasicInfoPopupClose()" [button_text]="'save' | translate"
        [visible]="openStudentBasicInfoPopup ? 'block' : 'none'" [studentName]="studentBasicInfoStudentName"
        [studentId]="studentBasicInfoStudentId" [academicId]="academicId"
        [schoolCurrency]="schoolCurrency"></app-student-basic-info>
      <app-student-contact-info *ngIf="openStudentContactInfoPopup" (save_button_event)="afterStudentContactInfoSaved()"
        (closePopup)="studentContactInfoPopupClose()" [button_text]="'save' | translate"
        [visible]="openStudentContactInfoPopup ? 'block' : 'none'" [studentName]="studentContactInfoStudentName"
        [studentId]="studentContactInfoStudentId" [academicId]="academicId"
        [schoolCurrency]="schoolCurrency"></app-student-contact-info>
      <app-student-profile-view *ngIf="openStudentProfileViewPopup" (closePopup)="studentProfileViewClose()"
        [visible]="openStudentProfileViewPopup ? 'block' : 'none'" [studentName]="studentProfileViewStudentName"
        [studentId]="studentProfileViewStudentId" [academicId]="academicId"></app-student-profile-view>
    </div>
  </div>
  <!--end #base-->
</div>
<!-- Delete Profile pic Modal popup -->
<div class="modal fade delete-staff-profile-pic" id="deleteStaffPopup" tabindex="-1" role="dialog"
  aria-labelledby="simpleModalLabel" aria-hidden="true" data-backdrop="static">
  <div class="modal-dialog">
    <div class="modal-content col-md-12" style=" padding: 0;">
      <div class="modal-body" style="padding: 0;">
        <h3 style="cursor: pointer;text-align: right; margin-top: 0rem;" data-dismiss="modal"
          id="deleteStaffPopupClose"><i class="fa fa-close"></i></h3>
        <p style="margin-left: 15px;"> {{ 'areYouSureYouWantToDeleteProfilePicture' | translate }}</p>
        <div class="modal-footer">
          <button *ngIf="!removeStaffProfilePicStatus" class="btn btn-primary active"
            (click)="removeStaffProfilePic()">{{ 'yes' | translate }}</button>
          <button type="button" class="btn btn-primary active" data-dismiss="modal">{{ 'no' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>



<div
class="modal"
id="documentHubData"
tabindex="-1"
role="dialog"
aria-labelledby="simpleModalLabel"
aria-hidden="true"
>
<div class="modal-dialog document-hub-main-container" role="document">
  <div class="modal-content document-hub-pop-up-main-container" (click)="closeActionsFromDocument()">
    <div (click)="closeActionsFromDocument()"  class="header-of-document-hub">
      <div class="close-document-hub" ><i (click)="closeDocumentHubPopUp()" class="ri-close-large-line close-document-hub-icon"></i></div>
      <div class="main-heading-document-hub">
        {{ 'documentHub' | translate }}
      </div>
      <div class="student-detail-document-hub">
        <div class="registration-number-document"><span class="registration-number-string">{{ 'registrationNumber' | translate }}:</span> <span class="data-string-doc-hub">{{registrationIdDocHub}}</span></div>
        <div class="registration-name-document"><span class="registration-number-string">{{ 'student' | translate }}:</span> <span class="data-string-doc-hub">{{studentBasicInfoStudentName}}</span></div>
      </div>
    </div>

   <div class="main-container-uploaded-document" *ngIf="!isOpenUploadDocument">
    <div (click)="closeActionsFromDocument()" class="search-and-entries-in-doc-hub">
      <div *ngIf="uploadedDocumentList.length>0 && !fetchingUploadedDocumentList" class="search-doc">
       <span>{{ 'search' | translate }}:</span> <input #searchType (input)="searchDocumentsByTitle(searchType.value)" class="search-option-entries-doc-hub" type="text">
      </div>
    </div>

    <div class="table-for-doc-hub">
       <div *ngIf="!fetchingUploadedDocumentList">
        <table *ngIf="documentHubData.length>0" class="table-for-doc-hub-main-container">
          <thead (click)="closeActionsFromDocument()">
            <tr >
              <th>{{ 'documentType' | translate }}</th>
              <th>{{ 'documentTitle' | translate }}</th>
              <th>{{ 'description' | translate }}</th>
              <th>{{ 'uploadedOn' | translate }}</th>
              <th>{{ 'uploadedBy' | translate }}</th>
              <th>{{ 'action' | translate }}</th>
            </tr>
          </thead>
          <tbody class="table-tbody-doc-hub-main-container">
            <tr [ngStyle]="{ 'pointer-events': deletingDocument ? 'none' : 'auto' }" class="document-hub-table-row" *ngFor="let key of documentHubData;let i = index" (click)="handleMediaPreviewDocumentHub(key,i)">
              <td  >{{key.documentTypeName}}</td>
              <td  >{{key.documentTitle}}</td>
              <td  >{{key.documentDescription}}</td>
              <td>{{key.createdOn}}</td>
              <td>{{key.createdBy}}</td>
              <td class="actions-td-doc">
                <i  *ngIf="previewingDocumentIndex===''"    class="ri-more-2-line" (click)="openActionsForDocument(i)" ></i>
                <div *ngIf="previewingDocumentIndex===i" >
                  <app-button-loader
                  [borderStyle]="'3px solid var(--brand-primary-color)'"
                ></app-button-loader>
                </div>
                <div  *ngIf="documentIndex===i" class="document-action-container" >
                  <!-- <div class="edit-document">Edit</div> -->
                  <div (click)="deleteUploadedDoc(key)" class="delete-document"><span>{{ 'delete' | translate }}</span> <span>
                    <div *ngIf="deletingDocument" class="loader-delete-document">
                      <app-button-loader
                      [borderStyle]="'3px solid var(--brand-primary-color)'"
                    ></app-button-loader>
                    </div>
                  </span></div>
                </div>
              </td>
              
            </tr>
          </tbody>
        </table>
          <div *ngIf="documentHubData.length==0" class="no-data-available">
              <img class="no-data-icon" src="../../assets/img/ no_data_available.png" alt="">
              <div class="message-no-document">
                {{ 'noDocumentsAvailableForSelectedStudent' | translate }}
              </div>
            </div>
      </div>
      <div *ngIf="fetchingUploadedDocumentList" class="loader-for-document-list">
        <app-button-loader
        [borderStyle]="'3px solid var(--brand-primary-color)'"
      ></app-button-loader>
      </div>
    </div>
    <div class="add-document-row-doc-hub">
      <div (click)="openUploadDocument()" class="add-document-doc-hub">
       {{ 'addDocument' | translate }}
      </div>
      </div>
   </div>

   <div class="main-container-for-upload-document"  *ngIf="isOpenUploadDocument">
   <div>
    <div class="input-box-for-upload-document-main-container">
     
      <div class="document-type-doc">
        <label for="" class="label-input-box-doc">{{ 'documentType' | translate }} <span class="mandatory"><sup>*</sup></span></label>
        <select [(ngModel)]="selectedDocumentType"  class="select-box-doc" name="" id="">
          <option value="null"  hidden>{{ 'selectDocument' | translate }}</option>
          <option *ngFor="let item of documentTypesInfo"  [ngValue]="item">{{item.documentTypeName}}</option>
        </select>

        <div *ngIf="fetchingDocumentType" class="loader-for-getting-document">
          <app-button-loader
          [borderStyle]="'3px solid var(--brand-primary-color)'"
        ></app-button-loader>
        </div>
      </div>
      <div [ngClass]="{
        'document-type-doc-disable': selectedDocumentType?.documentTypeName != 'Other',
        'document-type-doc': selectedDocumentType?.documentTypeName == 'Other'
      }">
        <label for="" class="label-input-box-doc">{{ 'documentTitle' | translate }} <span class="mandatory"><sup>*</sup></span></label>

        <input #documentTitle class="select-box-doc" [maxLength]="50" type="text">
      </div>
      <div class="document-type-doc">
        <label for="" class="label-input-box-doc">{{ 'uploadDocument' | translate }} <span class="mandatory"><sup>*</sup></span></label>
        <label for="file-upload-doc" class="file-upload-box-doc">
          <div class="file-name-for-document-hub">{{selectedFileForUpload ? 'Uploaded' : null}}</div>
          <img class="upload-dochub-doc" src="../../assets/img/upload-document.png" alt="">
         </label>
        <input (change)="uploadDocumentForDocHub($event)" #fileInputDocumentHub [accept]="selectedDocumentType? selectedDocumentType?.allowedFormat :null"  id="file-upload-doc" type="file">
      </div>
    </div>
    <div class="description-for-upload-doc-main-container">
      <label for="" class="label-input-box-doc">{{ 'documentDescription' | translate }}</label>
      <textarea [maxLength]="200" #documentDescription  class="description-for-upload-doc" rows="8" name="" id=""></textarea>
    </div>

    <div class="button-for-upload-cancel">
      <div   class="cancel-button-add-doc">
        <button (click)="openUploadDocument()" [disabled]="uploadingDocument">{{ 'cancel' | translate }}</button>
      </div>
      <div class="add-button-doc">
        <button [disabled]="uploadingDocument" (click)="uploadFilesForDochub(documentTitle.value,documentDescription.value)">
          <span  *ngIf="!uploadingDocument">{{ 'upload' | translate }}</span>
          <app-button-loader *ngIf="uploadingDocument"></app-button-loader>
        </button>
      </div>
    </div>
   </div>
   </div>
    
    
  </div>
</div>
</div>